(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './ktor-ktor-utils.js', './kotlinx-atomicfu.js', './ktor-ktor-events.js', './ktor-ktor-io.js', './ktor-ktor-http.js', './ktor-ktor-websockets.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./ktor-ktor-utils.js'), require('./kotlinx-atomicfu.js'), require('./ktor-ktor-events.js'), require('./ktor-ktor-io.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-websockets.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof this['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof this['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof this['ktor-ktor-events'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-events' was not found. Please, check whether 'ktor-ktor-events' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof this['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof this['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof this['ktor-ktor-websockets'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-websockets' was not found. Please, check whether 'ktor-ktor-websockets' is loaded prior to 'ktor-ktor-client-core'.");
    }
    root['ktor-ktor-client-core'] = factory(typeof this['ktor-ktor-client-core'] === 'undefined' ? {} : this['ktor-ktor-client-core'], this['kotlin-kotlin-stdlib'], this['kotlinx-coroutines-core'], this['ktor-ktor-utils'], this['kotlinx-atomicfu'], this['ktor-ktor-events'], this['ktor-ktor-io'], this['ktor-ktor-http'], this['ktor-ktor-websockets']);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_utils, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_io_ktor_ktor_events, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_websockets) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.hb;
  var objectCreate = kotlin_kotlin.$_$.gb;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d1;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var CoroutineImpl = kotlin_kotlin.$_$.j9;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var PipelineContext = kotlin_io_ktor_ktor_utils.$_$.h;
  var toString = kotlin_kotlin.$_$.lb;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.u1;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.v8;
  var initMetadataForLambda = kotlin_kotlin.$_$.la;
  var VOID = kotlin_kotlin.$_$.g;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ja;
  var atomic$boolean$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.b;
  var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z;
  var AttributesJsFn = kotlin_io_ktor_ktor_utils.$_$.n;
  var Events = kotlin_io_ktor_ktor_events.$_$.b;
  var AttributeKey = kotlin_io_ktor_ktor_utils.$_$.m;
  var Closeable = kotlin_io_ktor_ktor_io.$_$.s;
  var isInterface = kotlin_kotlin.$_$.va;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var ensureNotNull = kotlin_kotlin.$_$.ef;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var PlatformUtils_getInstance = kotlin_io_ktor_ktor_utils.$_$.c;
  var ByteReadChannel = kotlin_io_ktor_ktor_io.$_$.h1;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ia;
  var instanceOf = kotlin_io_ktor_ktor_utils.$_$.k;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var equals = kotlin_kotlin.$_$.z9;
  var cancel_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f1;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.of;
  var IllegalStateException = kotlin_kotlin.$_$.ie;
  var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.s1;
  var captureStack = kotlin_kotlin.$_$.r9;
  var defineProp = kotlin_kotlin.$_$.y9;
  var UnsupportedOperationException = kotlin_kotlin.$_$.ze;
  var UnsupportedOperationException_init_$Init$ = kotlin_kotlin.$_$.g2;
  var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
  var trimIndent = kotlin_kotlin.$_$.vd;
  var ByteReadChannel_0 = kotlin_io_ktor_ktor_io.$_$.g1;
  var readBytes = kotlin_io_ktor_ktor_io.$_$.x;
  var IllegalStateException_init_$Init$_0 = kotlin_kotlin.$_$.t1;
  var WriterScope = kotlin_io_ktor_ktor_io.$_$.i1;
  var ReadChannelContent = kotlin_io_ktor_ktor_http.$_$.n;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.lf;
  var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k;
  var writer = kotlin_io_ktor_ktor_io.$_$.l1;
  var WriteChannelContent = kotlin_io_ktor_ktor_http.$_$.o;
  var Companion_getInstance = kotlin_io_ktor_ktor_io.$_$.h;
  var NoContent = kotlin_io_ktor_ktor_http.$_$.l;
  var ProtocolUpgrade = kotlin_io_ktor_ktor_http.$_$.m;
  var ByteArrayContent = kotlin_io_ktor_ktor_http.$_$.k;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var JsType_instance = kotlin_io_ktor_ktor_utils.$_$.b;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.t4;
  var arrayOf = kotlin_kotlin.$_$.bf;
  var createKType = kotlin_kotlin.$_$.c;
  var typeInfoImpl = kotlin_io_ktor_ktor_utils.$_$.l;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.p;
  var get_job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
  var async = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c1;
  var emptySet = kotlin_kotlin.$_$.u6;
  var initMetadataForInterface = kotlin_kotlin.$_$.ka;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var UnsafeHeaderException = kotlin_io_ktor_ktor_http.$_$.w;
  var CancellationException_init_$Create$ = kotlin_kotlin.$_$.z;
  var CoroutineName = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var SilentSupervisor = kotlin_io_ktor_ktor_utils.$_$.o;
  var lazy = kotlin_kotlin.$_$.kf;
  var CompletableJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v;
  var KProperty1 = kotlin_kotlin.$_$.zb;
  var getPropertyCallableRef = kotlin_kotlin.$_$.ea;
  var setOf = kotlin_kotlin.$_$.c8;
  var get = kotlin_kotlin.$_$.f9;
  var fold = kotlin_kotlin.$_$.e9;
  var minusKey = kotlin_kotlin.$_$.g9;
  var plus = kotlin_kotlin.$_$.i9;
  var Element = kotlin_kotlin.$_$.h9;
  var joinToString = kotlin_kotlin.$_$.i7;
  var setOf_0 = kotlin_kotlin.$_$.d8;
  var PipelinePhase = kotlin_io_ktor_ktor_utils.$_$.i;
  var initMetadataForObject = kotlin_kotlin.$_$.ma;
  var contentLength = kotlin_io_ktor_ktor_http.$_$.d1;
  var Companion_getInstance_0 = kotlin_io_ktor_ktor_http.$_$.i;
  var charSequenceLength = kotlin_kotlin.$_$.v9;
  var URLBuilder = kotlin_io_ktor_ktor_http.$_$.u;
  var ParametersBuilder = kotlin_io_ktor_ktor_http.$_$.t;
  var appendAll = kotlin_io_ktor_ktor_utils.$_$.u;
  var takeFrom = kotlin_io_ktor_ktor_http.$_$.j1;
  var first = kotlin_kotlin.$_$.z6;
  var checkBuilderCapacity = kotlin_kotlin.$_$.y5;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.k;
  var HeadersBuilder = kotlin_io_ktor_ktor_http.$_$.r;
  var URLBuilder_0 = kotlin_io_ktor_ktor_http.$_$.v;
  var KtorSimpleLogger = kotlin_io_ktor_ktor_utils.$_$.g;
  var MalformedInputException = kotlin_io_ktor_ktor_io.$_$.i;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var toLong = kotlin_kotlin.$_$.jb;
  var toLong_0 = kotlin_kotlin.$_$.od;
  var contentType = kotlin_io_ktor_ktor_http.$_$.e1;
  var isByteArray = kotlin_kotlin.$_$.pa;
  var Text_getInstance = kotlin_io_ktor_ktor_http.$_$.c;
  var TextContent = kotlin_io_ktor_ktor_http.$_$.q;
  var Long = kotlin_kotlin.$_$.je;
  var copyTo = kotlin_io_ktor_ktor_io.$_$.a;
  var CancellationException = kotlin_kotlin.$_$.u8;
  var cancel_1 = kotlin_io_ktor_ktor_io.$_$.j1;
  var HttpStatusCode = kotlin_io_ktor_ktor_http.$_$.s;
  var getKClass = kotlin_kotlin.$_$.f;
  var toByteArray = kotlin_io_ktor_ktor_utils.$_$.a;
  var Input = kotlin_io_ktor_ktor_io.$_$.t;
  var ByteReadPacket = kotlin_io_ktor_ktor_io.$_$.r;
  var Unit = kotlin_kotlin.$_$.ye;
  var Companion_getInstance_1 = kotlin_io_ktor_ktor_http.$_$.f;
  var toString_0 = kotlin_kotlin.$_$.pf;
  var toInt = kotlin_kotlin.$_$.md;
  var reversed = kotlin_kotlin.$_$.b8;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.w;
  var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.g;
  var charset = kotlin_io_ktor_ktor_http.$_$.c1;
  var withCharset = kotlin_io_ktor_ktor_http.$_$.m1;
  var compareValues = kotlin_kotlin.$_$.t8;
  var get_name = kotlin_io_ktor_ktor_io.$_$.m;
  var toList = kotlin_kotlin.$_$.k8;
  var sortedWith = kotlin_kotlin.$_$.h8;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.d1;
  var roundToInt = kotlin_kotlin.$_$.nb;
  var firstOrNull = kotlin_kotlin.$_$.x6;
  var charset_0 = kotlin_io_ktor_ktor_http.$_$.b1;
  var readText = kotlin_io_ktor_ktor_io.$_$.z;
  var get_authority = kotlin_io_ktor_ktor_http.$_$.a1;
  var takeFrom_0 = kotlin_io_ktor_ktor_http.$_$.k1;
  var isSecure = kotlin_io_ktor_ktor_http.$_$.g1;
  var get_authority_0 = kotlin_io_ktor_ktor_http.$_$.z;
  var EventDefinition = kotlin_io_ktor_ktor_events.$_$.a;
  var Companion_getInstance_2 = kotlin_io_ktor_ktor_http.$_$.h;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b1;
  var cancel_2 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g1;
  var trimMargin = kotlin_kotlin.$_$.wd;
  var get_lastIndex = kotlin_kotlin.$_$.l7;
  var downTo = kotlin_kotlin.$_$.sb;
  var delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c;
  var isWebsocket = kotlin_io_ktor_ktor_http.$_$.h1;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i1;
  var IOException = kotlin_io_ktor_ktor_io.$_$.d1;
  var IOException_init_$Init$ = kotlin_io_ktor_ktor_io.$_$.e;
  var Companion_instance = kotlin_kotlin.$_$.y4;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.u2;
  var createFailure = kotlin_kotlin.$_$.df;
  var discard = kotlin_io_ktor_ktor_io.$_$.b;
  var split = kotlin_io_ktor_ktor_utils.$_$.a1;
  var IllegalStateException_init_$Init$_1 = kotlin_kotlin.$_$.v1;
  var putAll = kotlin_io_ktor_ktor_utils.$_$.z;
  var GMTDate = kotlin_io_ktor_ktor_utils.$_$.e;
  var Pipeline = kotlin_io_ktor_ktor_utils.$_$.j;
  var decode = kotlin_io_ktor_ktor_io.$_$.j;
  var hashCode = kotlin_kotlin.$_$.ga;
  var get_ByteArrayPool = kotlin_io_ktor_ktor_io.$_$.e1;
  var readAvailable = kotlin_io_ktor_ktor_io.$_$.c;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var equals_0 = kotlin_kotlin.$_$.hc;
  var flatten = kotlin_kotlin.$_$.a7;
  var copyToArray = kotlin_kotlin.$_$.o6;
  var get_platform = kotlin_io_ktor_ktor_utils.$_$.y;
  var Companion_getInstance_3 = kotlin_io_ktor_ktor_http.$_$.g;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x;
  var CancellationException_init_$Create$_0 = kotlin_kotlin.$_$.b1;
  var cancel_3 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e1;
  var Companion_getInstance_4 = kotlin_io_ktor_ktor_http.$_$.d;
  var intercepted = kotlin_kotlin.$_$.x8;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.t;
  var extendThrowable = kotlin_kotlin.$_$.aa;
  var toTypedArray = kotlin_kotlin.$_$.r8;
  var writeFully = kotlin_io_ktor_ktor_io.$_$.d;
  var Error_init_$Create$ = kotlin_kotlin.$_$.f1;
  var Error_init_$Create$_0 = kotlin_kotlin.$_$.h1;
  var _ChannelResult___get_isSuccess__impl__odq1z9 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g;
  var Channel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.m;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.k4;
  var Companion_getInstance_5 = kotlin_io_ktor_ktor_websockets.$_$.f;
  var Codes_CLOSED_ABNORMALLY_getInstance = kotlin_io_ktor_ktor_websockets.$_$.a;
  var Text_init_$Create$ = kotlin_io_ktor_ktor_websockets.$_$.e;
  var Binary_init_$Create$ = kotlin_io_ktor_ktor_websockets.$_$.c;
  var CloseReason = kotlin_io_ktor_ktor_websockets.$_$.g;
  var Close_init_$Create$ = kotlin_io_ktor_ktor_websockets.$_$.d;
  var String_0 = kotlin_io_ktor_ktor_io.$_$.u;
  var BytePacketBuilder = kotlin_io_ktor_ktor_io.$_$.q;
  var writeFully_0 = kotlin_io_ktor_ktor_io.$_$.a1;
  var readShort = kotlin_io_ktor_ktor_io.$_$.y;
  var cancelConsumed = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n;
  var Codes_NORMAL_getInstance = kotlin_io_ktor_ktor_websockets.$_$.b;
  var CompletableDeferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u;
  //endregion
  //region block: pre-declaration
  initMetadataForLambda(HttpClient$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpClient$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($executeCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(HttpClient, 'HttpClient', VOID, VOID, [CoroutineScope, Closeable], [1]);
  initMetadataForClass(HttpClientConfig, 'HttpClientConfig', HttpClientConfig);
  initMetadataForCompanion(Companion);
  initMetadataForCoroutine($bodyNullableCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(HttpClientCall, 'HttpClientCall', VOID, VOID, [CoroutineScope], [0, 1]);
  initMetadataForClass(DoubleReceiveException, 'DoubleReceiveException', VOID, IllegalStateException);
  initMetadataForClass(NoTransformationFoundException, 'NoTransformationFoundException', VOID, UnsupportedOperationException);
  initMetadataForClass(SavedHttpCall, 'SavedHttpCall', VOID, HttpClientCall, VOID, [0, 1]);
  function get_coroutineContext() {
    return this.h3x().pj();
  }
  initMetadataForInterface(HttpRequest_0, 'HttpRequest', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(SavedHttpRequest, 'SavedHttpRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForClass(HttpResponse, 'HttpResponse', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(SavedHttpResponse, 'SavedHttpResponse', VOID, HttpResponse);
  initMetadataForCoroutine($saveCOROUTINE$3, CoroutineImpl);
  initMetadataForClass(UnsupportedContentTypeException, 'UnsupportedContentTypeException', VOID, IllegalStateException);
  initMetadataForLambda(ObservableContent$content$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ObservableContent, 'ObservableContent', VOID, ReadChannelContent);
  initMetadataForLambda(HttpClientEngine$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpClientEngine$executeWithinCallContext$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($executeWithinCallContextCOROUTINE$4, CoroutineImpl);
  function get_supportedCapabilities() {
    return emptySet();
  }
  function install(client) {
    var tmp = Phases_getInstance_0().t3u_1;
    client.c3s_1.t3b(tmp, HttpClientEngine$install$slambda_0(client, this, null));
  }
  initMetadataForInterface(HttpClientEngine, 'HttpClientEngine', VOID, VOID, [CoroutineScope, Closeable], [1]);
  initMetadataForClass(ClientEngineClosedException, 'ClientEngineClosedException', ClientEngineClosedException, IllegalStateException);
  initMetadataForClass(HttpClientEngineBase, 'HttpClientEngineBase', VOID, VOID, [HttpClientEngine], [1]);
  initMetadataForClass(HttpClientEngineConfig, 'HttpClientEngineConfig', HttpClientEngineConfig);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(KtorCallContextElement, 'KtorCallContextElement', VOID, VOID, [Element]);
  initMetadataForInterface(HttpClientPlugin, 'HttpClientPlugin');
  initMetadataForObject(Plugin, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForLambda(BodyProgress$handle$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(BodyProgress$handle$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(BodyProgress, 'BodyProgress');
  initMetadataForLambda(DefaultRequest$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(Plugin_0, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(DefaultRequestBuilder, 'DefaultRequestBuilder');
  initMetadataForClass(DefaultRequest, 'DefaultRequest');
  initMetadataForClass(ResponseException, 'ResponseException', VOID, IllegalStateException);
  initMetadataForClass(RedirectResponseException, 'RedirectResponseException', VOID, ResponseException);
  initMetadataForClass(ClientRequestException, 'ClientRequestException', VOID, ResponseException);
  initMetadataForClass(ServerResponseException, 'ServerResponseException', VOID, ResponseException);
  initMetadataForLambda(addDefaultResponseValidation$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(defaultTransformers$1$content$1, VOID, VOID, ByteArrayContent);
  initMetadataForClass(defaultTransformers$1$content$2, VOID, VOID, ReadChannelContent);
  initMetadataForLambda(defaultTransformers$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(defaultTransformers$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(defaultTransformers$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$Companion$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$Companion$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$Companion$install$slambda_3, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config, 'Config', Config);
  initMetadataForCompanion(Companion_1, VOID, [HttpClientPlugin]);
  initMetadataForCoroutine($validateResponseCOROUTINE$5, CoroutineImpl);
  initMetadataForCoroutine($processExceptionCOROUTINE$6, CoroutineImpl);
  initMetadataForClass(HttpCallValidator, 'HttpCallValidator', VOID, VOID, VOID, [1, 2]);
  initMetadataForClass(ExceptionHandlerWrapper, 'ExceptionHandlerWrapper');
  initMetadataForClass(RequestExceptionHandlerWrapper, 'RequestExceptionHandlerWrapper');
  initMetadataForClass(HttpRequest$1, VOID, VOID, VOID, [HttpRequest_0]);
  initMetadataForLambda(HttpPlainText$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpPlainText$Plugin$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config_0, 'Config', Config_0);
  initMetadataForObject(Plugin_1, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0');
  initMetadataForClass(HttpPlainText, 'HttpPlainText');
  initMetadataForLambda(HttpRedirect$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($handleCallCOROUTINE$7, CoroutineImpl);
  initMetadataForClass(Config_1, 'Config', Config_1);
  initMetadataForObject(Plugin_2, 'Plugin', VOID, VOID, [HttpClientPlugin], [4]);
  initMetadataForClass(HttpRedirect, 'HttpRedirect');
  initMetadataForLambda(HttpRequestLifecycle$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(Plugin_3, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(HttpRequestLifecycle, 'HttpRequestLifecycle');
  initMetadataForLambda(HttpSend$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($executeCOROUTINE$8, CoroutineImpl);
  initMetadataForClass(Config_2, 'Config', Config_2);
  initMetadataForObject(Plugin_4, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForInterface(Sender, 'Sender', VOID, VOID, VOID, [1]);
  initMetadataForClass(InterceptedSender, 'InterceptedSender', VOID, VOID, [Sender], [1]);
  initMetadataForClass(DefaultSender, 'DefaultSender', VOID, VOID, [Sender], [1]);
  initMetadataForClass(HttpSend, 'HttpSend');
  initMetadataForClass(SendCountExceedException, 'SendCountExceedException', VOID, IllegalStateException);
  initMetadataForCompanion(Companion_2);
  initMetadataForLambda(HttpTimeout$Plugin$install$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HttpTimeout$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(HttpTimeoutCapabilityConfiguration, 'HttpTimeoutCapabilityConfiguration', HttpTimeoutCapabilityConfiguration_init_$Create$);
  initMetadataForObject(Plugin_5, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(HttpTimeout, 'HttpTimeout');
  initMetadataForClass(HttpRequestTimeoutException, 'HttpRequestTimeoutException', VOID, IOException);
  initMetadataForClass(DelegatedCall, 'DelegatedCall', VOID, HttpClientCall, VOID, [0, 1]);
  initMetadataForClass(DelegatedRequest, 'DelegatedRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForClass(DelegatedResponse, 'DelegatedResponse', VOID, HttpResponse);
  initMetadataForLambda(ResponseObserver$Config$responseHandler$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ResponseObserver$Plugin$install$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ResponseObserver$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config_3, 'Config', Config_3);
  initMetadataForObject(Plugin_6, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(ResponseObserver, 'ResponseObserver');
  initMetadataForObject(WebSocketCapability, 'WebSocketCapability');
  initMetadataForClass(WebSocketException, 'WebSocketException', VOID, IllegalStateException);
  initMetadataForClass(ClientUpgradeContent, 'ClientUpgradeContent', VOID, NoContent, VOID, [1]);
  initMetadataForClass(DefaultHttpRequest, 'DefaultHttpRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(HttpRequestBuilder, 'HttpRequestBuilder', HttpRequestBuilder);
  initMetadataForClass(HttpRequestData, 'HttpRequestData');
  initMetadataForClass(HttpResponseData, 'HttpResponseData');
  initMetadataForObject(Phases, 'Phases');
  initMetadataForClass(HttpRequestPipeline, 'HttpRequestPipeline', HttpRequestPipeline, Pipeline, VOID, [2]);
  initMetadataForObject(Phases_0, 'Phases');
  initMetadataForClass(HttpSendPipeline, 'HttpSendPipeline', HttpSendPipeline, Pipeline, VOID, [2]);
  initMetadataForClass(DefaultHttpResponse, 'DefaultHttpResponse', VOID, HttpResponse);
  initMetadataForCoroutine($bodyAsTextCOROUTINE$22, CoroutineImpl);
  initMetadataForObject(Phases_1, 'Phases');
  initMetadataForClass(HttpResponsePipeline, 'HttpResponsePipeline', HttpResponsePipeline, Pipeline, VOID, [2]);
  initMetadataForObject(Phases_2, 'Phases');
  initMetadataForClass(HttpReceivePipeline, 'HttpReceivePipeline', HttpReceivePipeline, Pipeline, VOID, [2]);
  initMetadataForClass(HttpResponseContainer, 'HttpResponseContainer');
  initMetadataForLambda(HttpStatement$execute$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($executeCOROUTINE$23, CoroutineImpl);
  initMetadataForCoroutine($executeUnsafeCOROUTINE$24, CoroutineImpl);
  initMetadataForCoroutine($cleanupCOROUTINE$25, CoroutineImpl);
  initMetadataForClass(HttpStatement, 'HttpStatement', VOID, VOID, VOID, [1, 0]);
  initMetadataForLambda(observable$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(HttpResponseReceiveFail, 'HttpResponseReceiveFail');
  initMetadataForObject(EmptyContent, 'EmptyContent', VOID, NoContent);
  initMetadataForObject(Js, 'Js');
  initMetadataForClass(JsClientEngine$createWebSocket$headers_capturingHack$1);
  initMetadataForCoroutine($executeCOROUTINE$26, CoroutineImpl);
  initMetadataForCoroutine($executeWebSocketRequestCOROUTINE$27, CoroutineImpl);
  initMetadataForClass(JsClientEngine, 'JsClientEngine', VOID, HttpClientEngineBase, VOID, [1, 2]);
  initMetadataForClass(JsError, 'JsError', VOID, Error);
  initMetadataForLambda(toRaw$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($toRawCOROUTINE$28, CoroutineImpl);
  initMetadataForLambda(channelFromStream$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(readBodyNode$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsWebSocketSession$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(JsWebSocketSession, 'JsWebSocketSession', VOID, VOID, [CoroutineScope], [0, 1]);
  //endregion
  function HttpClient_init_$Init$(engine, userConfig, manageEngine, $this) {
    HttpClient.call($this, engine, userConfig);
    $this.w3r_1 = manageEngine;
    return $this;
  }
  function HttpClient_init_$Create$(engine, userConfig, manageEngine) {
    return HttpClient_init_$Init$(engine, userConfig, manageEngine, objectCreate(protoOf(HttpClient)));
  }
  function HttpClient$lambda(this$0) {
    return function (it) {
      var tmp;
      if (!(it == null)) {
        cancel(this$0.u3r_1);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HttpClient$slambda(this$0, resultContinuation) {
    this.q3s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClient$slambda).u3s = function ($this$intercept, call, $completion) {
    var tmp = this.v3s($this$intercept, call, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpClient$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClient$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            var tmp_0 = this.s3s_1;
            if (!(tmp_0 instanceof HttpClientCall)) {
              var message = 'Error: HttpClientCall expected, but found ' + toString(this.s3s_1) + '(' + toString(getKClassFromExpression(this.s3s_1)) + ').';
              throw IllegalStateException_init_$Create$(toString(message));
            }

            this.j8_1 = 1;
            suspendResult = this.q3s_1.d3s_1.o3b(Unit_instance, this.s3s_1.b3t(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.t3s_1 = suspendResult;
            this.s3s_1.c3t(this.t3s_1);
            this.j8_1 = 2;
            suspendResult = this.r3s_1.t3a(this.s3s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClient$slambda).v3s = function ($this$intercept, call, completion) {
    var i = new HttpClient$slambda(this.q3s_1, completion);
    i.r3s_1 = $this$intercept;
    i.s3s_1 = call;
    return i;
  };
  function HttpClient$slambda_0(this$0, resultContinuation) {
    var i = new HttpClient$slambda(this$0, resultContinuation);
    var l = function ($this$intercept, call, $completion) {
      return i.u3s($this$intercept, call, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpClient$lambda_0($this$install) {
    defaultTransformers($this$install);
    return Unit_instance;
  }
  function HttpClient$slambda_1(this$0, resultContinuation) {
    this.l3t_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClient$slambda_1).o3t = function ($this$intercept, it, $completion) {
    var tmp = this.p3t($this$intercept, it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpClient$slambda_1).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.o3t(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClient$slambda_1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.m3t_1.u3a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.k8_1 = 3;
            this.j8_1 = 4;
            continue $sm;
          case 2:
            this.k8_1 = 3;
            var tmp_0 = this.m8_1;
            if (tmp_0 instanceof Error) {
              var cause = this.m8_1;
              this.l3t_1.g3s_1.j3o(get_HttpResponseReceiveFailed(), new HttpResponseReceiveFail(this.m3t_1.p3b_1.b3t(), cause));
              throw cause;
            } else {
              throw this.m8_1;
            }

          case 3:
            throw this.m8_1;
          case 4:
            this.k8_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClient$slambda_1).p3t = function ($this$intercept, it, completion) {
    var i = new HttpClient$slambda_1(this.l3t_1, completion);
    i.m3t_1 = $this$intercept;
    i.n3t_1 = it;
    return i;
  };
  function HttpClient$slambda_2(this$0, resultContinuation) {
    var i = new HttpClient$slambda_1(this$0, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.o3t($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $executeCOROUTINE$0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y3t_1 = _this__u8e3s4;
    this.z3t_1 = builder;
  }
  protoOf($executeCOROUTINE$0).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.y3t_1.g3s_1.j3o(get_HttpRequestCreated(), this.z3t_1);
            this.j8_1 = 1;
            suspendResult = this.y3t_1.a3s_1.o3b(this.z3t_1, this.z3t_1.d3u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult instanceof HttpClientCall ? suspendResult : THROW_CCE();
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function HttpClient(engine, userConfig) {
    userConfig = userConfig === VOID ? new HttpClientConfig() : userConfig;
    this.u3r_1 = engine;
    this.v3r_1 = userConfig;
    this.w3r_1 = false;
    this.x3r_1 = atomic$boolean$1(false);
    this.y3r_1 = Job(this.u3r_1.pj().w8(Key_instance));
    this.z3r_1 = this.u3r_1.pj().le(this.y3r_1);
    this.a3s_1 = new HttpRequestPipeline(this.v3r_1.n3u_1);
    this.b3s_1 = new HttpResponsePipeline(this.v3r_1.n3u_1);
    this.c3s_1 = new HttpSendPipeline(this.v3r_1.n3u_1);
    this.d3s_1 = new HttpReceivePipeline(this.v3r_1.n3u_1);
    this.e3s_1 = AttributesJsFn(true);
    this.f3s_1 = this.u3r_1.o3u();
    this.g3s_1 = new Events();
    this.h3s_1 = new HttpClientConfig();
    if (this.w3r_1) {
      this.y3r_1.rk(HttpClient$lambda(this));
    }
    this.u3r_1.p3u(this);
    var tmp = Phases_getInstance_0().u3u_1;
    this.c3s_1.t3b(tmp, HttpClient$slambda_0(this, null));
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    var $this$with = this.v3r_1;
    this.h3s_1.v3u(Plugin_getInstance_3());
    this.h3s_1.v3u(Plugin_getInstance());
    if ($this$with.l3u_1) {
      this.h3s_1.w3u('DefaultTransformers', HttpClient$lambda_0);
    }
    this.h3s_1.v3u(Plugin_getInstance_4());
    this.h3s_1.v3u(Companion_getInstance_8());
    if ($this$with.k3u_1) {
      this.h3s_1.v3u(Plugin_getInstance_2());
    }
    this.h3s_1.x3u($this$with);
    if ($this$with.l3u_1) {
      this.h3s_1.v3u(Plugin_getInstance_1());
    }
    addDefaultResponseValidation(this.h3s_1);
    this.h3s_1.p3u(this);
    var tmp_0 = Phases_getInstance_1().y3u_1;
    this.b3s_1.t3b(tmp_0, HttpClient$slambda_2(this, null));
  }
  protoOf(HttpClient).pj = function () {
    return this.z3r_1;
  };
  protoOf(HttpClient).d3v = function (builder, $completion) {
    var tmp = new $executeCOROUTINE$0(this, builder, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpClient).j2z = function () {
    var success = this.x3r_1.atomicfu$compareAndSet(false, true);
    if (!success)
      return Unit_instance;
    var installedFeatures = this.e3s_1.p34(get_PLUGIN_INSTALLED_LIST());
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = installedFeatures.v34().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.client.HttpClient.close.<anonymous>' call
      var plugin = installedFeatures.p34(element instanceof AttributeKey ? element : THROW_CCE());
      if (isInterface(plugin, Closeable)) {
        plugin.j2z();
      }
    }
    this.y3r_1.mr();
    if (this.w3r_1) {
      this.u3r_1.j2z();
    }
  };
  protoOf(HttpClient).toString = function () {
    return 'HttpClient[' + toString(this.u3r_1) + ']';
  };
  function HttpClient_0(engineFactory, block) {
    var tmp;
    if (block === VOID) {
      tmp = HttpClient$lambda_1;
    } else {
      tmp = block;
    }
    block = tmp;
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpClientConfig();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var config = this_0;
    var engine = engineFactory.e3v(config.j3u_1);
    var client = HttpClient_init_$Create$(engine, config, true);
    var tmp_0 = ensureNotNull(client.z3r_1.w8(Key_instance));
    tmp_0.rk(HttpClient$lambda_2(engine));
    return client;
  }
  function HttpClient$lambda_1($this$null) {
    return Unit_instance;
  }
  function HttpClient$lambda_2($engine) {
    return function (it) {
      $engine.j2z();
      return Unit_instance;
    };
  }
  function HttpClientConfig$engineConfig$lambda($this$null) {
    return Unit_instance;
  }
  function HttpClientConfig$install$lambda($this$null) {
    return Unit_instance;
  }
  function HttpClientConfig$install$lambda_0($previousConfigBlock, $configure) {
    return function ($this$null) {
      var tmp0_safe_receiver = $previousConfigBlock;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver($this$null);
      $configure(!($this$null == null) ? $this$null : THROW_CCE());
      return Unit_instance;
    };
  }
  function HttpClientConfig$install$lambda$lambda() {
    return AttributesJsFn(true);
  }
  function HttpClientConfig$install$lambda_1($plugin) {
    return function (scope) {
      var tmp = get_PLUGIN_INSTALLED_LIST();
      var attributes = scope.e3s_1.u34(tmp, HttpClientConfig$install$lambda$lambda);
      var config = ensureNotNull(scope.h3s_1.h3u_1.y1($plugin.u()));
      var pluginData = $plugin.f3v(config);
      $plugin.g3v(pluginData, scope);
      attributes.s34($plugin.u(), pluginData);
      return Unit_instance;
    };
  }
  function HttpClientConfig() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.g3u_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.h3u_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.i3u_1 = LinkedHashMap_init_$Create$();
    var tmp_2 = this;
    tmp_2.j3u_1 = HttpClientConfig$engineConfig$lambda;
    this.k3u_1 = true;
    this.l3u_1 = true;
    this.m3u_1 = false;
    this.n3u_1 = PlatformUtils_getInstance().i38_1;
  }
  protoOf(HttpClientConfig).h3v = function (plugin, configure) {
    var previousConfigBlock = this.h3u_1.y1(plugin.u());
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.h3u_1;
    var key = plugin.u();
    var value = HttpClientConfig$install$lambda_0(previousConfigBlock, configure);
    this_0.b2(key, value);
    if (this.g3u_1.w1(plugin.u()))
      return Unit_instance;
    // Inline function 'kotlin.collections.set' call
    var this_1 = this.g3u_1;
    var key_0 = plugin.u();
    var value_0 = HttpClientConfig$install$lambda_1(plugin);
    this_1.b2(key_0, value_0);
  };
  protoOf(HttpClientConfig).v3u = function (plugin, configure, $super) {
    var tmp;
    if (configure === VOID) {
      tmp = HttpClientConfig$install$lambda;
    } else {
      tmp = configure;
    }
    configure = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.h3v(plugin, configure);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.h3v.call(this, plugin, configure);
    }
    return tmp_0;
  };
  protoOf(HttpClientConfig).w3u = function (key, block) {
    // Inline function 'kotlin.collections.set' call
    this.i3u_1.b2(key, block);
  };
  protoOf(HttpClientConfig).p3u = function (client) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.g3u_1.a2().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.client.HttpClientConfig.install.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      element(client);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.i3u_1.a2().g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'io.ktor.client.HttpClientConfig.install.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      element_0(client);
    }
  };
  protoOf(HttpClientConfig).x3u = function (other) {
    this.k3u_1 = other.k3u_1;
    this.l3u_1 = other.l3u_1;
    this.m3u_1 = other.m3u_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.g3u_1;
    var map = other.g3u_1;
    this_0.d2(map);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.h3u_1;
    var map_0 = other.h3u_1;
    this_1.d2(map_0);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_2 = this.i3u_1;
    var map_1 = other.i3u_1;
    this_2.d2(map_1);
  };
  function HttpClientCall_init_$Init$(client, requestData, responseData, $this) {
    HttpClientCall.call($this, client);
    $this.y3s_1 = new DefaultHttpRequest($this, requestData);
    $this.z3s_1 = new DefaultHttpResponse($this, responseData);
    var tmp = responseData.m3v_1;
    if (!isInterface(tmp, ByteReadChannel)) {
      $this.p2i().s34(Companion_getInstance_6().p3v_1, responseData.m3v_1);
    }
    return $this;
  }
  function HttpClientCall_init_$Create$(client, requestData, responseData) {
    return HttpClientCall_init_$Init$(client, requestData, responseData, objectCreate(protoOf(HttpClientCall)));
  }
  function Companion() {
    Companion_instance_0 = this;
    this.p3v_1 = new AttributeKey('CustomResponse');
  }
  var Companion_instance_0;
  function Companion_getInstance_6() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function $bodyNullableCOROUTINE$1(_this__u8e3s4, info, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y3v_1 = _this__u8e3s4;
    this.z3v_1 = info;
  }
  protoOf($bodyNullableCOROUTINE$1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 10;
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.a3w_1 = Unit_instance;
            this.j8_1 = 2;
            continue $sm;
          case 2:
            this.k8_1 = 9;
            this.k8_1 = 8;
            if (instanceOf(this.y3v_1.b3t(), this.z3v_1.h3c_1)) {
              this.a3w_1 = this.y3v_1.b3t();
              this.k8_1 = 10;
              this.j8_1 = 7;
              continue $sm;
            } else {
              this.j8_1 = 3;
              continue $sm;
            }

          case 3:
            if (!this.y3v_1.f3w() && !this.y3v_1.x3s_1.atomicfu$compareAndSet(false, true)) {
              throw new DoubleReceiveException(this.y3v_1);
            }

            this.b3w_1 = this.y3v_1.p2i().q34(Companion_getInstance_6().p3v_1);
            if (this.b3w_1 == null) {
              this.j8_1 = 4;
              suspendResult = this.y3v_1.g3w(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.c3w_1 = this.b3w_1;
              this.j8_1 = 5;
              continue $sm;
            }

          case 4:
            this.c3w_1 = suspendResult;
            this.j8_1 = 5;
            continue $sm;
          case 5:
            this.d3w_1 = this.c3w_1;
            this.e3w_1 = new HttpResponseContainer(this.z3v_1, this.d3w_1);
            this.j8_1 = 6;
            suspendResult = this.y3v_1.w3s_1.b3s_1.o3b(this.y3v_1, this.e3w_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            var this_0 = ARGUMENT.i3w_1;
            var tmp_0;
            if (!equals(this_0, NullBody_instance)) {
              tmp_0 = this_0;
            } else {
              tmp_0 = null;
            }

            var result = tmp_0;
            if (!(result == null) && !instanceOf(result, this.z3v_1.h3c_1)) {
              var from = getKClassFromExpression(result);
              var to = this.z3v_1.h3c_1;
              throw new NoTransformationFoundException(this.y3v_1.b3t(), from, to);
            }

            this.a3w_1 = result;
            this.k8_1 = 10;
            this.j8_1 = 7;
            var tmp_1 = this;
            continue $sm;
          case 7:
            var tmp_2 = this.a3w_1;
            this.k8_1 = 10;
            complete(this.y3v_1.b3t());
            return tmp_2;
          case 8:
            this.k8_1 = 9;
            var tmp_3 = this.m8_1;
            if (tmp_3 instanceof Error) {
              var cause = this.m8_1;
              var tmp_4 = this;
              cancel_0(this.y3v_1.b3t(), 'Receive failed', cause);
              throw cause;
            } else {
              throw this.m8_1;
            }

          case 9:
            this.k8_1 = 10;
            var t = this.m8_1;
            complete(this.y3v_1.b3t());
            throw t;
          case 10:
            throw this.m8_1;
          case 11:
            this.k8_1 = 10;
            complete(this.y3v_1.b3t());
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 10) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function HttpClientCall(client) {
    Companion_getInstance_6();
    this.w3s_1 = client;
    this.x3s_1 = atomic$boolean$1(false);
    this.a3t_1 = false;
  }
  protoOf(HttpClientCall).pj = function () {
    return this.b3t().pj();
  };
  protoOf(HttpClientCall).p2i = function () {
    return this.j3w().p2i();
  };
  protoOf(HttpClientCall).j3w = function () {
    var tmp = this.y3s_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('request');
    }
  };
  protoOf(HttpClientCall).b3t = function () {
    var tmp = this.z3s_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('response');
    }
  };
  protoOf(HttpClientCall).f3w = function () {
    return this.a3t_1;
  };
  protoOf(HttpClientCall).g3w = function ($completion) {
    return this.b3t().k3w();
  };
  protoOf(HttpClientCall).l3w = function (info, $completion) {
    var tmp = new $bodyNullableCOROUTINE$1(this, info, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpClientCall).toString = function () {
    return 'HttpClientCall[' + this.j3w().m3w().toString() + ', ' + this.b3t().u3n().toString() + ']';
  };
  protoOf(HttpClientCall).c3t = function (response) {
    this.z3s_1 = response;
  };
  function DoubleReceiveException(call) {
    IllegalStateException_init_$Init$(this);
    captureStack(this, DoubleReceiveException);
    this.n3w_1 = 'Response already received: ' + call.toString();
  }
  protoOf(DoubleReceiveException).z8 = function () {
    return this.n3w_1;
  };
  function NoTransformationFoundException(response, from, to) {
    UnsupportedOperationException_init_$Init$(this);
    captureStack(this, NoTransformationFoundException);
    this.o3w_1 = trimIndent("\n        Expected response body of the type '" + toString(to) + "' but was '" + toString(from) + "'\n        In response from `" + get_request(response).m3w().toString() + '`\n        Response status `' + response.u3n().toString() + '`\n        Response header `ContentType: ' + response.p3i().w2i(HttpHeaders_getInstance().e3f_1) + '` \n        Request header `Accept: ' + get_request(response).p3i().w2i(HttpHeaders_getInstance().m3e_1) + '`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ');
  }
  protoOf(NoTransformationFoundException).z8 = function () {
    return this.o3w_1;
  };
  function save(_this__u8e3s4, $completion) {
    var tmp = new $saveCOROUTINE$3(_this__u8e3s4, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function SavedHttpCall(client, request, response, responseBody) {
    HttpClientCall.call(this, client);
    this.d3x_1 = responseBody;
    this.y3s_1 = new SavedHttpRequest(this, request);
    this.z3s_1 = new SavedHttpResponse(this, this.d3x_1, response);
    this.e3x_1 = true;
  }
  protoOf(SavedHttpCall).g3w = function ($completion) {
    return ByteReadChannel_0(this.d3x_1);
  };
  protoOf(SavedHttpCall).f3w = function () {
    return this.e3x_1;
  };
  function SavedHttpRequest(call, origin) {
    this.f3x_1 = call;
    this.g3x_1 = origin;
  }
  protoOf(SavedHttpRequest).h3x = function () {
    return this.f3x_1;
  };
  protoOf(SavedHttpRequest).p2i = function () {
    return this.g3x_1.p2i();
  };
  protoOf(SavedHttpRequest).pj = function () {
    return this.g3x_1.pj();
  };
  protoOf(SavedHttpRequest).p3i = function () {
    return this.g3x_1.p3i();
  };
  protoOf(SavedHttpRequest).i3x = function () {
    return this.g3x_1.i3x();
  };
  protoOf(SavedHttpRequest).m3w = function () {
    return this.g3x_1.m3w();
  };
  function SavedHttpResponse(call, body, origin) {
    HttpResponse.call(this);
    this.j3x_1 = call;
    this.k3x_1 = Job();
    this.l3x_1 = origin.u3n();
    this.m3x_1 = origin.s3x();
    this.n3x_1 = origin.t3x();
    this.o3x_1 = origin.u3x();
    this.p3x_1 = origin.p3i();
    this.q3x_1 = origin.pj().le(this.k3x_1);
    this.r3x_1 = ByteReadChannel_0(body);
  }
  protoOf(SavedHttpResponse).h3x = function () {
    return this.j3x_1;
  };
  protoOf(SavedHttpResponse).u3n = function () {
    return this.l3x_1;
  };
  protoOf(SavedHttpResponse).s3x = function () {
    return this.m3x_1;
  };
  protoOf(SavedHttpResponse).t3x = function () {
    return this.n3x_1;
  };
  protoOf(SavedHttpResponse).u3x = function () {
    return this.o3x_1;
  };
  protoOf(SavedHttpResponse).p3i = function () {
    return this.p3x_1;
  };
  protoOf(SavedHttpResponse).pj = function () {
    return this.q3x_1;
  };
  protoOf(SavedHttpResponse).k3w = function () {
    return this.r3x_1;
  };
  function $saveCOROUTINE$3(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x3w_1 = _this__u8e3s4;
  }
  protoOf($saveCOROUTINE$3).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.x3w_1.b3t().k3w().i2w(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var responseBody = readBytes(ARGUMENT);
            return new SavedHttpCall(this.x3w_1.w3s_1, this.x3w_1.j3w(), this.x3w_1.b3t(), responseBody);
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function UnsupportedContentTypeException(content) {
    IllegalStateException_init_$Init$_0('Failed to write body: ' + toString(getKClassFromExpression(content)), this);
    captureStack(this, UnsupportedContentTypeException);
  }
  function ObservableContent$content$slambda(this$0, resultContinuation) {
    this.d3y_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ObservableContent$content$slambda).f3y = function ($this$writer, $completion) {
    var tmp = this.g3y($this$writer, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(ObservableContent$content$slambda).m9 = function (p1, $completion) {
    return this.f3y((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ObservableContent$content$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.d3y_1.i3y_1.b3o(this.e3y_1.fw(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(ObservableContent$content$slambda).g3y = function ($this$writer, completion) {
    var i = new ObservableContent$content$slambda(this.d3y_1, completion);
    i.e3y_1 = $this$writer;
    return i;
  };
  function ObservableContent$content$slambda_0(this$0, resultContinuation) {
    var i = new ObservableContent$content$slambda(this$0, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.f3y($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ObservableContent(delegate, callContext, listener) {
    ReadChannelContent.call(this);
    this.i3y_1 = delegate;
    this.j3y_1 = callContext;
    this.k3y_1 = listener;
    var tmp = this;
    var tmp0_subject = this.i3y_1;
    var tmp_0;
    if (tmp0_subject instanceof ByteArrayContent) {
      tmp_0 = ByteReadChannel_0(this.i3y_1.w3n());
    } else {
      if (tmp0_subject instanceof ProtocolUpgrade) {
        throw new UnsupportedContentTypeException(this.i3y_1);
      } else {
        if (tmp0_subject instanceof NoContent) {
          tmp_0 = Companion_getInstance().u2p();
        } else {
          if (tmp0_subject instanceof ReadChannelContent) {
            tmp_0 = this.i3y_1.z3n();
          } else {
            if (tmp0_subject instanceof WriteChannelContent) {
              var tmp_1 = GlobalScope_instance;
              tmp_0 = writer(tmp_1, this.j3y_1, true, ObservableContent$content$slambda_0(this, null)).fw();
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
    tmp.l3y_1 = tmp_0;
  }
  protoOf(ObservableContent).t3n = function () {
    return this.i3y_1.t3n();
  };
  protoOf(ObservableContent).v3n = function () {
    return this.i3y_1.v3n();
  };
  protoOf(ObservableContent).u3n = function () {
    return this.i3y_1.u3n();
  };
  protoOf(ObservableContent).p3i = function () {
    return this.i3y_1.p3i();
  };
  protoOf(ObservableContent).z3n = function () {
    return observable(this.l3y_1, this.j3y_1, this.v3n(), this.k3y_1);
  };
  function get_CALL_COROUTINE() {
    _init_properties_HttpClientEngine_kt__h91z5h();
    return CALL_COROUTINE;
  }
  var CALL_COROUTINE;
  function get_CLIENT_CONFIG() {
    _init_properties_HttpClientEngine_kt__h91z5h();
    return CLIENT_CONFIG;
  }
  var CLIENT_CONFIG;
  function HttpClientEngine$install$slambda$lambda($client, $response) {
    return function (it) {
      var tmp;
      if (!(it == null)) {
        $client.g3s_1.j3o(get_HttpResponseCancelled(), $response);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function _get_closed__iwkfs1($this) {
    var tmp0_safe_receiver = $this.pj().w8(Key_instance);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qj();
    return !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
  }
  function executeWithinCallContext($this, requestData, $completion) {
    var tmp = new $executeWithinCallContextCOROUTINE$4($this, requestData, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function checkExtensions($this, requestData) {
    var tmp0_iterator = requestData.e3z_1.g();
    while (tmp0_iterator.h()) {
      var requestedExtension = tmp0_iterator.i();
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!$this.f3z().r(requestedExtension)) {
        // Inline function 'io.ktor.client.engine.HttpClientEngine.checkExtensions.<anonymous>' call
        var message = "Engine doesn't support " + toString(requestedExtension);
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
  }
  function HttpClientEngine$install$slambda($client, this$0, resultContinuation) {
    this.o3z_1 = $client;
    this.p3z_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClientEngine$install$slambda).u3s = function ($this$intercept, content, $completion) {
    var tmp = this.v3s($this$intercept, content, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpClientEngine$install$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClientEngine$install$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            var tmp_0 = this;
            var this_0 = new HttpRequestBuilder();
            this_0.x3z(this.q3z_1.p3b_1);
            var body = this.r3z_1;
            if (body == null) {
              this_0.d3u_1 = NullBody_instance;
              var tmp_1 = JsType_instance;
              var tmp_2 = PrimitiveClasses_getInstance().ga();
              var tmp_3;
              try {
                tmp_3 = createKType(PrimitiveClasses_getInstance().ga(), arrayOf([]), false);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_4 = null;
                } else {
                  throw $p;
                }
                tmp_3 = tmp_4;
              }
              this_0.y3z(typeInfoImpl(tmp_1, tmp_2, tmp_3));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.d3u_1 = body;
                this_0.y3z(null);
              } else {
                this_0.d3u_1 = body;
                var tmp_5 = JsType_instance;
                var tmp_6 = PrimitiveClasses_getInstance().ga();
                var tmp_7;
                try {
                  tmp_7 = createKType(PrimitiveClasses_getInstance().ga(), arrayOf([]), false);
                } catch ($p) {
                  var tmp_8;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_8 = null;
                  } else {
                    throw $p;
                  }
                  tmp_7 = tmp_8;
                }
                this_0.y3z(typeInfoImpl(tmp_5, tmp_6, tmp_7));
              }
            }

            tmp_0.s3z_1 = this_0;
            this.o3z_1.g3s_1.j3o(get_HttpRequestIsReadyForSending(), this.s3z_1);
            var tmp_9 = this;
            var this_1 = this.s3z_1.b21();
            this_1.d3z_1.s34(get_CLIENT_CONFIG(), this.o3z_1.h3s_1);
            tmp_9.t3z_1 = this_1;
            validateHeaders(this.t3z_1);
            checkExtensions(this.p3z_1, this.t3z_1);
            this.j8_1 = 1;
            suspendResult = executeWithinCallContext(this.p3z_1, this.t3z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u3z_1 = suspendResult;
            this.v3z_1 = HttpClientCall_init_$Create$(this.o3z_1, this.t3z_1, this.u3z_1);
            this.w3z_1 = this.v3z_1.b3t();
            this.o3z_1.g3s_1.j3o(get_HttpResponseReceived(), this.w3z_1);
            var tmp_10 = get_job(this.w3z_1.pj());
            tmp_10.rk(HttpClientEngine$install$slambda$lambda(this.o3z_1, this.w3z_1));
            this.j8_1 = 2;
            suspendResult = this.q3z_1.t3a(this.v3z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClientEngine$install$slambda).v3s = function ($this$intercept, content, completion) {
    var i = new HttpClientEngine$install$slambda(this.o3z_1, this.p3z_1, completion);
    i.q3z_1 = $this$intercept;
    i.r3z_1 = content;
    return i;
  };
  function HttpClientEngine$install$slambda_0($client, this$0, resultContinuation) {
    var i = new HttpClientEngine$install$slambda($client, this$0, resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.u3s($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData, resultContinuation) {
    this.h40_1 = this$0;
    this.i40_1 = $requestData;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).k40 = function ($this$async, $completion) {
    var tmp = this.m17($this$async, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).m9 = function (p1, $completion) {
    return this.k40((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            if (_get_closed__iwkfs1(this.h40_1)) {
              throw new ClientEngineClosedException();
            }

            this.j8_1 = 1;
            suspendResult = this.h40_1.l40(this.i40_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).m17 = function ($this$async, completion) {
    var i = new HttpClientEngine$executeWithinCallContext$slambda(this.h40_1, this.i40_1, completion);
    i.j40_1 = $this$async;
    return i;
  };
  function HttpClientEngine$executeWithinCallContext$slambda_0(this$0, $requestData, resultContinuation) {
    var i = new HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.k40($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $executeWithinCallContextCOROUTINE$4(_this__u8e3s4, requestData, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u3y_1 = _this__u8e3s4;
    this.v3y_1 = requestData;
  }
  protoOf($executeWithinCallContextCOROUTINE$4).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            this.j8_1 = 1;
            suspendResult = createCallContext(this.u3y_1, this.v3y_1.c3z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.w3y_1 = suspendResult;
            this.x3y_1 = this.w3y_1.le(new KtorCallContextElement(this.w3y_1));
            this.j8_1 = 2;
            suspendResult = async(this.u3y_1, this.x3y_1, VOID, HttpClientEngine$executeWithinCallContext$slambda_0(this.u3y_1, this.v3y_1, null)).mo(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function HttpClientEngine() {
  }
  function validateHeaders(request) {
    _init_properties_HttpClientEngine_kt__h91z5h();
    var requestHeaders = request.a3z_1;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = requestHeaders.m38();
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.client.engine.validateHeaders.<anonymous>' call
      if (HttpHeaders_getInstance().h3i_1.r(element)) {
        destination.e(element);
      }
    }
    var unsafeRequestHeaders = destination;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!unsafeRequestHeaders.o()) {
      throw new UnsafeHeaderException(toString(unsafeRequestHeaders));
    }
  }
  function createCallContext(_this__u8e3s4, parentJob, $completion) {
    var callJob = Job(parentJob);
    var callContext = _this__u8e3s4.pj().le(callJob).le(get_CALL_COROUTINE());
    $l$block: {
      // Inline function 'io.ktor.client.engine.attachToUserJob' call
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp0_elvis_lhs = $completion.p8().w8(Key_instance);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var userJob = tmp;
      var cleanupHandler = userJob.tk(true, VOID, createCallContext$lambda(callJob));
      callJob.rk(createCallContext$lambda_0(cleanupHandler));
    }
    return callContext;
  }
  function createCallContext$lambda($callJob) {
    return function (cause) {
      if (cause == null)
        return Unit_instance;
      $callJob.xk(CancellationException_init_$Create$(cause.message));
      return Unit_instance;
    };
  }
  function createCallContext$lambda_0($cleanupHandler) {
    return function (it) {
      $cleanupHandler.im();
      return Unit_instance;
    };
  }
  var properties_initialized_HttpClientEngine_kt_5uiebb;
  function _init_properties_HttpClientEngine_kt__h91z5h() {
    if (!properties_initialized_HttpClientEngine_kt_5uiebb) {
      properties_initialized_HttpClientEngine_kt_5uiebb = true;
      CALL_COROUTINE = new CoroutineName('call-context');
      CLIENT_CONFIG = new AttributeKey('client-config');
    }
  }
  function ClientEngineClosedException(cause) {
    cause = cause === VOID ? null : cause;
    IllegalStateException_init_$Init$_0('Client already closed', this);
    captureStack(this, ClientEngineClosedException);
    this.m40_1 = cause;
  }
  protoOf(ClientEngineClosedException).a9 = function () {
    return this.m40_1;
  };
  function HttpClientEngineBase$coroutineContext$delegate$lambda(this$0) {
    return function () {
      return SilentSupervisor().le(this$0.r40()).le(new CoroutineName(this$0.n40_1 + '-context'));
    };
  }
  function HttpClientEngineBase(engineName) {
    this.n40_1 = engineName;
    this.o40_1 = atomic$boolean$1(false);
    this.p40_1 = ioDispatcher();
    var tmp = this;
    tmp.q40_1 = lazy(HttpClientEngineBase$coroutineContext$delegate$lambda(this));
  }
  protoOf(HttpClientEngineBase).r40 = function () {
    return this.p40_1;
  };
  protoOf(HttpClientEngineBase).pj = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q40_1;
    coroutineContext$factory();
    return this_0.v();
  };
  protoOf(HttpClientEngineBase).j2z = function () {
    if (!this.o40_1.atomicfu$compareAndSet(false, true))
      return Unit_instance;
    var tmp = this.pj().w8(Key_instance);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, CompletableJob) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var requestJob = tmp_0;
    requestJob.mr();
  };
  function coroutineContext$factory() {
    return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
      return receiver.pj();
    }, null);
  }
  function get_ENGINE_CAPABILITIES_KEY() {
    _init_properties_HttpClientEngineCapability_kt__ifvyst();
    return ENGINE_CAPABILITIES_KEY;
  }
  var ENGINE_CAPABILITIES_KEY;
  var DEFAULT_CAPABILITIES;
  var properties_initialized_HttpClientEngineCapability_kt_qarzcf;
  function _init_properties_HttpClientEngineCapability_kt__ifvyst() {
    if (!properties_initialized_HttpClientEngineCapability_kt_qarzcf) {
      properties_initialized_HttpClientEngineCapability_kt_qarzcf = true;
      ENGINE_CAPABILITIES_KEY = new AttributeKey('EngineCapabilities');
      DEFAULT_CAPABILITIES = setOf(Plugin_getInstance_5());
    }
  }
  function HttpClientEngineConfig() {
    this.s40_1 = 4;
    this.t40_1 = false;
    this.u40_1 = null;
  }
  function get_KTOR_DEFAULT_USER_AGENT() {
    _init_properties_Utils_kt__jo07cx();
    return KTOR_DEFAULT_USER_AGENT;
  }
  var KTOR_DEFAULT_USER_AGENT;
  function get_DATE_HEADERS() {
    _init_properties_Utils_kt__jo07cx();
    return DATE_HEADERS;
  }
  var DATE_HEADERS;
  function Companion_0() {
  }
  var Companion_instance_1;
  function Companion_getInstance_7() {
    return Companion_instance_1;
  }
  function KtorCallContextElement(callContext) {
    this.v40_1 = callContext;
  }
  protoOf(KtorCallContextElement).u = function () {
    return Companion_instance_1;
  };
  function callContext($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.p8();
    return ensureNotNull(tmp$ret$0.w8(Companion_instance_1)).v40_1;
  }
  function mergeHeaders(requestHeaders, content, block) {
    _init_properties_Utils_kt__jo07cx();
    var tmp = buildHeaders(mergeHeaders$lambda(requestHeaders, content));
    tmp.o38(mergeHeaders$lambda_0(block));
    var missingAgent = requestHeaders.w2i(HttpHeaders_getInstance().k3h_1) == null && content.p3i().w2i(HttpHeaders_getInstance().k3h_1) == null;
    if (missingAgent && needUserAgent()) {
      block(HttpHeaders_getInstance().k3h_1, get_KTOR_DEFAULT_USER_AGENT());
    }
    var tmp0_safe_receiver = content.t3n();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? content.p3i().w2i(HttpHeaders_getInstance().e3f_1) : tmp1_elvis_lhs;
    var type = tmp2_elvis_lhs == null ? requestHeaders.w2i(HttpHeaders_getInstance().e3f_1) : tmp2_elvis_lhs;
    var tmp3_safe_receiver = content.v3n();
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
    var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? content.p3i().w2i(HttpHeaders_getInstance().b3f_1) : tmp4_elvis_lhs;
    var length = tmp5_elvis_lhs == null ? requestHeaders.w2i(HttpHeaders_getInstance().b3f_1) : tmp5_elvis_lhs;
    if (type == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      block(HttpHeaders_getInstance().e3f_1, type);
    }
    if (length == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      block(HttpHeaders_getInstance().b3f_1, length);
    }
  }
  function needUserAgent() {
    _init_properties_Utils_kt__jo07cx();
    return !PlatformUtils_getInstance().e38_1;
  }
  function mergeHeaders$lambda($requestHeaders, $content) {
    return function ($this$buildHeaders) {
      $this$buildHeaders.y38($requestHeaders);
      $this$buildHeaders.y38($content.p3i());
      return Unit_instance;
    };
  }
  function mergeHeaders$lambda_0($block) {
    return function (key, values) {
      var tmp;
      if (HttpHeaders_getInstance().b3f_1 === key) {
        return Unit_instance;
      }
      var tmp_0;
      if (HttpHeaders_getInstance().e3f_1 === key) {
        return Unit_instance;
      }
      var tmp_1;
      if (get_DATE_HEADERS().r(key)) {
        var tmp0_iterator = values.g();
        while (tmp0_iterator.h()) {
          var element = tmp0_iterator.i();
          // Inline function 'io.ktor.client.engine.mergeHeaders.<anonymous>.<anonymous>' call
          $block(key, element);
        }
        tmp_1 = Unit_instance;
      } else {
        var separator = HttpHeaders_getInstance().f3f_1 === key ? '; ' : ',';
        tmp_1 = $block(key, joinToString(values, separator));
      }
      return Unit_instance;
    };
  }
  var properties_initialized_Utils_kt_xvi83j;
  function _init_properties_Utils_kt__jo07cx() {
    if (!properties_initialized_Utils_kt_xvi83j) {
      properties_initialized_Utils_kt_xvi83j = true;
      KTOR_DEFAULT_USER_AGENT = 'Ktor client';
      DATE_HEADERS = setOf_0([HttpHeaders_getInstance().h3f_1, HttpHeaders_getInstance().n3f_1, HttpHeaders_getInstance().z3f_1, HttpHeaders_getInstance().u3f_1, HttpHeaders_getInstance().y3f_1]);
    }
  }
  function get_UploadProgressListenerAttributeKey() {
    _init_properties_BodyProgress_kt__s0v569();
    return UploadProgressListenerAttributeKey;
  }
  var UploadProgressListenerAttributeKey;
  function get_DownloadProgressListenerAttributeKey() {
    _init_properties_BodyProgress_kt__s0v569();
    return DownloadProgressListenerAttributeKey;
  }
  var DownloadProgressListenerAttributeKey;
  function handle($this, scope) {
    var observableContentPhase = new PipelinePhase('ObservableContent');
    scope.a3s_1.q3b(Phases_getInstance().z40_1, observableContentPhase);
    scope.a3s_1.t3b(observableContentPhase, BodyProgress$handle$slambda_0(null));
    var tmp = Phases_getInstance_2().d41_1;
    scope.d3s_1.t3b(tmp, BodyProgress$handle$slambda_2(null));
  }
  function Plugin() {
    Plugin_instance = this;
    this.e41_1 = new AttributeKey('BodyProgress');
  }
  protoOf(Plugin).u = function () {
    return this.e41_1;
  };
  protoOf(Plugin).f41 = function (block) {
    return new BodyProgress();
  };
  protoOf(Plugin).f3v = function (block) {
    return this.f41(block);
  };
  protoOf(Plugin).g41 = function (plugin, scope) {
    handle(plugin, scope);
  };
  protoOf(Plugin).g3v = function (plugin, scope) {
    return this.g41(plugin instanceof BodyProgress ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance;
  function Plugin_getInstance() {
    if (Plugin_instance == null)
      new Plugin();
    return Plugin_instance;
  }
  function BodyProgress$handle$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BodyProgress$handle$slambda).u3s = function ($this$intercept, content, $completion) {
    var tmp = this.v3s($this$intercept, content, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(BodyProgress$handle$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(BodyProgress$handle$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.p41_1.p3b_1.f3u_1.q34(get_UploadProgressListenerAttributeKey());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.r41_1 = tmp_1;
            var tmp_2 = this;
            var tmp_3 = this.q41_1;
            tmp_2.s41_1 = new ObservableContent(tmp_3 instanceof OutgoingContent ? tmp_3 : THROW_CCE(), this.p41_1.p3b_1.e3u_1, this.r41_1);
            this.j8_1 = 1;
            suspendResult = this.p41_1.t3a(this.s41_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(BodyProgress$handle$slambda).v3s = function ($this$intercept, content, completion) {
    var i = new BodyProgress$handle$slambda(completion);
    i.p41_1 = $this$intercept;
    i.q41_1 = content;
    return i;
  };
  function BodyProgress$handle$slambda_0(resultContinuation) {
    var i = new BodyProgress$handle$slambda(resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.u3s($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function BodyProgress$handle$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BodyProgress$handle$slambda_1).f42 = function ($this$intercept, response, $completion) {
    var tmp = this.g42($this$intercept, response, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(BodyProgress$handle$slambda_1).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.f42(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
  };
  protoOf(BodyProgress$handle$slambda_1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.c42_1.h3x().j3w().p2i().q34(get_DownloadProgressListenerAttributeKey());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.d42_1 = tmp_1;
            this.e42_1 = withObservableDownload(this.c42_1, this.d42_1);
            this.j8_1 = 1;
            suspendResult = this.b42_1.t3a(this.e42_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(BodyProgress$handle$slambda_1).g42 = function ($this$intercept, response, completion) {
    var i = new BodyProgress$handle$slambda_1(completion);
    i.b42_1 = $this$intercept;
    i.c42_1 = response;
    return i;
  };
  function BodyProgress$handle$slambda_2(resultContinuation) {
    var i = new BodyProgress$handle$slambda_1(resultContinuation);
    var l = function ($this$intercept, response, $completion) {
      return i.f42($this$intercept, response, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function BodyProgress() {
    Plugin_getInstance();
  }
  function withObservableDownload(_this__u8e3s4, listener) {
    _init_properties_BodyProgress_kt__s0v569();
    var observableByteChannel = observable(_this__u8e3s4.k3w(), _this__u8e3s4.pj(), contentLength(_this__u8e3s4), listener);
    return wrapWithContent(_this__u8e3s4.h3x(), observableByteChannel).b3t();
  }
  var properties_initialized_BodyProgress_kt_pmfrhr;
  function _init_properties_BodyProgress_kt__s0v569() {
    if (!properties_initialized_BodyProgress_kt_pmfrhr) {
      properties_initialized_BodyProgress_kt_pmfrhr = true;
      UploadProgressListenerAttributeKey = new AttributeKey('UploadProgressListenerAttributeKey');
      DownloadProgressListenerAttributeKey = new AttributeKey('DownloadProgressListenerAttributeKey');
    }
  }
  function get_LOGGER() {
    _init_properties_DefaultRequest_kt__yzsodq();
    return LOGGER;
  }
  var LOGGER;
  function defaultRequest(_this__u8e3s4, block) {
    _init_properties_DefaultRequest_kt__yzsodq();
    var tmp = Plugin_getInstance_0();
    _this__u8e3s4.h3v(tmp, defaultRequest$lambda(block));
  }
  function mergeUrls($this, baseUrl, requestUrl) {
    if (requestUrl.q3l_1.equals(Companion_getInstance_0().t3m_1)) {
      requestUrl.q3l_1 = baseUrl.c3m_1;
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = requestUrl.r3l_1;
    if (charSequenceLength(this_0) > 0)
      return Unit_instance;
    var resultUrl = URLBuilder(baseUrl);
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.client.plugins.Plugin.mergeUrls.<anonymous>' call
    resultUrl.q3l_1 = requestUrl.q3l_1;
    if (!(requestUrl.s3l_1 === 0)) {
      resultUrl.s3l_1 = requestUrl.s3l_1;
    }
    resultUrl.x3l_1 = concatenatePath(Plugin_getInstance_0(), resultUrl.x3l_1, requestUrl.x3l_1);
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_1 = requestUrl.w3l_1;
    if (charSequenceLength(this_1) > 0) {
      resultUrl.w3l_1 = requestUrl.w3l_1;
    }
    // Inline function 'kotlin.apply' call
    var this_2 = ParametersBuilder();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.client.plugins.Plugin.mergeUrls.<anonymous>.<anonymous>' call
    appendAll(this_2, resultUrl.y3l_1);
    var defaultParameters = this_2;
    resultUrl.e3n(requestUrl.y3l_1);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = defaultParameters.n38().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.client.plugins.Plugin.mergeUrls.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.u();
      // Inline function 'kotlin.collections.component2' call
      var values = element.v();
      if (!resultUrl.y3l_1.t38(key)) {
        resultUrl.y3l_1.s38(key, values);
      }
    }
    takeFrom(requestUrl, resultUrl);
  }
  function concatenatePath($this, parent, child) {
    if (child.o())
      return parent;
    if (parent.o())
      return child;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = first(child);
    if (charSequenceLength(this_0) === 0)
      return child;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.buildListInternal' call
    var capacity = (parent.j() + child.j() | 0) - 1 | 0;
    checkBuilderCapacity(capacity);
    // Inline function 'kotlin.apply' call
    var this_1 = ArrayList_init_$Create$_0(capacity);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.client.plugins.Plugin.concatenatePath.<anonymous>' call
    var inductionVariable = 0;
    var last = parent.j() - 1 | 0;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_1.e(parent.p(index));
      }
       while (inductionVariable < last);
    this_1.n(child);
    return this_1.y4();
  }
  function DefaultRequest$Plugin$install$slambda($plugin, resultContinuation) {
    this.p42_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultRequest$Plugin$install$slambda).u3s = function ($this$intercept, it, $completion) {
    var tmp = this.v3s($this$intercept, it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(DefaultRequest$Plugin$install$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(DefaultRequest$Plugin$install$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        if (tmp === 0) {
          this.k8_1 = 1;
          var originalUrlString = this.q42_1.p3b_1.a3u_1.toString();
          var this_0 = new DefaultRequestBuilder();
          appendAll(this_0.s42_1, this.q42_1.p3b_1.c3u_1);
          this.p42_1.v42_1(this_0);
          var defaultRequest = this_0;
          var defaultUrl = defaultRequest.t42_1.b21();
          mergeUrls(Plugin_getInstance_0(), defaultUrl, this.q42_1.p3b_1.a3u_1);
          var tmp0_iterator = defaultRequest.u42_1.v34().g();
          while (tmp0_iterator.h()) {
            var element = tmp0_iterator.i();
            if (!this.q42_1.p3b_1.f3u_1.r34(element)) {
              this.q42_1.p3b_1.f3u_1.s34(element instanceof AttributeKey ? element : THROW_CCE(), defaultRequest.u42_1.p34(element));
            }
          }
          this.q42_1.p3b_1.c3u_1.s1();
          this.q42_1.p3b_1.c3u_1.y38(defaultRequest.s42_1.b21());
          get_LOGGER().m3c('Applied DefaultRequest to ' + originalUrlString + '. New url: ' + this.q42_1.p3b_1.a3u_1.toString());
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(DefaultRequest$Plugin$install$slambda).v3s = function ($this$intercept, it, completion) {
    var i = new DefaultRequest$Plugin$install$slambda(this.p42_1, completion);
    i.q42_1 = $this$intercept;
    i.r42_1 = it;
    return i;
  };
  function DefaultRequest$Plugin$install$slambda_0($plugin, resultContinuation) {
    var i = new DefaultRequest$Plugin$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.u3s($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Plugin_0() {
    Plugin_instance_0 = this;
    this.w42_1 = new AttributeKey('DefaultRequest');
  }
  protoOf(Plugin_0).u = function () {
    return this.w42_1;
  };
  protoOf(Plugin_0).x42 = function (block) {
    return new DefaultRequest(block);
  };
  protoOf(Plugin_0).f3v = function (block) {
    return this.x42(block);
  };
  protoOf(Plugin_0).y42 = function (plugin, scope) {
    var tmp = Phases_getInstance().w40_1;
    scope.a3s_1.t3b(tmp, DefaultRequest$Plugin$install$slambda_0(plugin, null));
  };
  protoOf(Plugin_0).g3v = function (plugin, scope) {
    return this.y42(plugin instanceof DefaultRequest ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_0;
  function Plugin_getInstance_0() {
    if (Plugin_instance_0 == null)
      new Plugin_0();
    return Plugin_instance_0;
  }
  function DefaultRequestBuilder() {
    this.s42_1 = new HeadersBuilder();
    this.t42_1 = new URLBuilder_0();
    this.u42_1 = AttributesJsFn(true);
  }
  protoOf(DefaultRequestBuilder).p3i = function () {
    return this.s42_1;
  };
  function DefaultRequest(block) {
    Plugin_getInstance_0();
    this.v42_1 = block;
  }
  function defaultRequest$lambda($block) {
    return function ($this$install) {
      $block($this$install);
      return Unit_instance;
    };
  }
  var properties_initialized_DefaultRequest_kt_au5efk;
  function _init_properties_DefaultRequest_kt__yzsodq() {
    if (!properties_initialized_DefaultRequest_kt_au5efk) {
      properties_initialized_DefaultRequest_kt_au5efk = true;
      LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultRequest');
    }
  }
  function get_ValidateMark() {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    return ValidateMark;
  }
  var ValidateMark;
  function get_LOGGER_0() {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    return LOGGER_0;
  }
  var LOGGER_0;
  function addDefaultResponseValidation(_this__u8e3s4) {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    HttpResponseValidator(_this__u8e3s4, addDefaultResponseValidation$lambda(_this__u8e3s4));
  }
  function ResponseException(response, cachedResponseText) {
    IllegalStateException_init_$Init$_0('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"', this);
    captureStack(this, ResponseException);
    this.z42_1 = response;
  }
  function RedirectResponseException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, RedirectResponseException);
    this.b43_1 = 'Unhandled redirect: ' + response.h3x().j3w().i3x().y3i_1 + ' ' + response.h3x().j3w().m3w().toString() + '. ' + ('Status: ' + response.u3n().toString() + '. Text: "' + cachedResponseText + '"');
  }
  protoOf(RedirectResponseException).z8 = function () {
    return this.b43_1;
  };
  function ClientRequestException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, ClientRequestException);
    this.d43_1 = 'Client request(' + response.h3x().j3w().i3x().y3i_1 + ' ' + response.h3x().j3w().m3w().toString() + ') ' + ('invalid: ' + response.u3n().toString() + '. Text: "' + cachedResponseText + '"');
  }
  protoOf(ClientRequestException).z8 = function () {
    return this.d43_1;
  };
  function ServerResponseException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, ServerResponseException);
    this.f43_1 = 'Server error(' + response.h3x().j3w().i3x().y3i_1 + ' ' + response.h3x().j3w().m3w().toString() + ': ' + (response.u3n().toString() + '. Text: "' + cachedResponseText + '"');
  }
  protoOf(ServerResponseException).z8 = function () {
    return this.f43_1;
  };
  function addDefaultResponseValidation$lambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(addDefaultResponseValidation$lambda$slambda).w43 = function (response, $completion) {
    var tmp = this.x43(response, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).m9 = function (p1, $completion) {
    return this.w43(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 5;
            this.p43_1 = this.o43_1.h3x().p2i().p34(get_ExpectSuccessAttributeKey());
            if (!this.p43_1) {
              get_LOGGER_0().m3c('Skipping default response validation for ' + this.o43_1.h3x().j3w().m3w().toString());
              return Unit_instance;
            }

            this.q43_1 = this.o43_1.u3n().k3l_1;
            this.r43_1 = this.o43_1.h3x();
            if (this.q43_1 < 300 || this.r43_1.p2i().r34(get_ValidateMark())) {
              return Unit_instance;
            }

            this.j8_1 = 1;
            suspendResult = save(this.r43_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.s43_1 = suspendResult;
            this.s43_1.p2i().s34(get_ValidateMark(), Unit_instance);
            this.t43_1 = this.s43_1;
            this.u43_1 = this.t43_1.b3t();
            this.k8_1 = 3;
            this.j8_1 = 2;
            suspendResult = bodyAsText(this.u43_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.v43_1 = suspendResult;
            this.k8_1 = 5;
            this.j8_1 = 4;
            continue $sm;
          case 3:
            this.k8_1 = 5;
            var tmp_0 = this.m8_1;
            if (tmp_0 instanceof MalformedInputException) {
              var _ = this.m8_1;
              var tmp_1 = this;
              tmp_1.v43_1 = '<body failed decoding>';
              this.j8_1 = 4;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 4:
            this.k8_1 = 5;
            var exceptionResponseText = this.v43_1;
            var tmp0_subject = this.q43_1;
            var exception = (300 <= tmp0_subject ? tmp0_subject <= 399 : false) ? new RedirectResponseException(this.u43_1, exceptionResponseText) : (400 <= tmp0_subject ? tmp0_subject <= 499 : false) ? new ClientRequestException(this.u43_1, exceptionResponseText) : (500 <= tmp0_subject ? tmp0_subject <= 599 : false) ? new ServerResponseException(this.u43_1, exceptionResponseText) : new ResponseException(this.u43_1, exceptionResponseText);
            get_LOGGER_0().m3c('Default response validation for ' + this.o43_1.h3x().j3w().m3w().toString() + ' failed with ' + exception.toString());
            throw exception;
          case 5:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 5) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).x43 = function (response, completion) {
    var i = new addDefaultResponseValidation$lambda$slambda(completion);
    i.o43_1 = response;
    return i;
  };
  function addDefaultResponseValidation$lambda$slambda_0(resultContinuation) {
    var i = new addDefaultResponseValidation$lambda$slambda(resultContinuation);
    var l = function (response, $completion) {
      return i.w43(response, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function addDefaultResponseValidation$lambda($this_addDefaultResponseValidation) {
    return function ($this$HttpResponseValidator) {
      $this$HttpResponseValidator.a44_1 = $this_addDefaultResponseValidation.m3u_1;
      $this$HttpResponseValidator.b44(addDefaultResponseValidation$lambda$slambda_0(null));
      return Unit_instance;
    };
  }
  var properties_initialized_DefaultResponseValidation_kt_akvzqt;
  function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
    if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
      properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
      ValidateMark = new AttributeKey('ValidateMark');
      LOGGER_0 = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
    }
  }
  function get_LOGGER_1() {
    _init_properties_DefaultTransform_kt__20knxx();
    return LOGGER_1;
  }
  var LOGGER_1;
  function defaultTransformers(_this__u8e3s4) {
    _init_properties_DefaultTransform_kt__20knxx();
    var tmp = Phases_getInstance().z40_1;
    _this__u8e3s4.a3s_1.t3b(tmp, defaultTransformers$slambda_0(null));
    var tmp_0 = Phases_getInstance_1().z3u_1;
    _this__u8e3s4.b3s_1.t3b(tmp_0, defaultTransformers$slambda_2(null));
    platformResponseDefaultTransformers(_this__u8e3s4);
  }
  function defaultTransformers$1$content$1($contentType, $body) {
    this.f44_1 = $body;
    ByteArrayContent.call(this);
    var tmp = this;
    tmp.d44_1 = $contentType == null ? Application_getInstance().d3d_1 : $contentType;
    this.e44_1 = toLong($body.length);
  }
  protoOf(defaultTransformers$1$content$1).t3n = function () {
    return this.d44_1;
  };
  protoOf(defaultTransformers$1$content$1).v3n = function () {
    return this.e44_1;
  };
  protoOf(defaultTransformers$1$content$1).w3n = function () {
    return this.f44_1;
  };
  function defaultTransformers$1$content$2($this_intercept, $contentType, $body) {
    this.j44_1 = $body;
    ReadChannelContent.call(this);
    var tmp = this;
    var tmp0_safe_receiver = $this_intercept.p3b_1.c3u_1.w2i(HttpHeaders_getInstance().b3f_1);
    tmp.h44_1 = tmp0_safe_receiver == null ? null : toLong_0(tmp0_safe_receiver);
    var tmp_0 = this;
    tmp_0.i44_1 = $contentType == null ? Application_getInstance().d3d_1 : $contentType;
  }
  protoOf(defaultTransformers$1$content$2).v3n = function () {
    return this.h44_1;
  };
  protoOf(defaultTransformers$1$content$2).t3n = function () {
    return this.i44_1;
  };
  protoOf(defaultTransformers$1$content$2).z3n = function () {
    return this.j44_1;
  };
  function defaultTransformers$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda).u3s = function ($this$intercept, body, $completion) {
    var tmp = this.v3s($this$intercept, body, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(defaultTransformers$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            if (this.s44_1.p3b_1.c3u_1.w2i(HttpHeaders_getInstance().m3e_1) == null) {
              this.s44_1.p3b_1.c3u_1.x38(HttpHeaders_getInstance().m3e_1, '*/*');
            }

            this.u44_1 = contentType(this.s44_1.p3b_1);
            var tmp_0 = this;
            var tmp0_subject = this.t44_1;
            var tmp_1;
            if (typeof tmp0_subject === 'string') {
              var tmp1_elvis_lhs = this.u44_1;
              tmp_1 = new TextContent(this.t44_1, tmp1_elvis_lhs == null ? Text_getInstance().t3d_1 : tmp1_elvis_lhs);
            } else {
              if (isByteArray(tmp0_subject)) {
                tmp_1 = new defaultTransformers$1$content$1(this.u44_1, this.t44_1);
              } else {
                if (isInterface(tmp0_subject, ByteReadChannel)) {
                  tmp_1 = new defaultTransformers$1$content$2(this.s44_1, this.u44_1, this.t44_1);
                } else {
                  if (tmp0_subject instanceof OutgoingContent) {
                    tmp_1 = this.t44_1;
                  } else {
                    tmp_1 = platformRequestDefaultTransform(this.u44_1, this.s44_1.p3b_1, this.t44_1);
                  }
                }
              }
            }

            tmp_0.v44_1 = tmp_1;
            var tmp2_safe_receiver = this.v44_1;
            if (!((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.t3n()) == null)) {
              this.s44_1.p3b_1.c3u_1.z38(HttpHeaders_getInstance().e3f_1);
              get_LOGGER_1().m3c('Transformed with default transformers request body for ' + this.s44_1.p3b_1.a3u_1.toString() + ' from ' + toString(getKClassFromExpression(this.t44_1)));
              this.j8_1 = 1;
              suspendResult = this.s44_1.t3a(this.v44_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.j8_1 = 2;
              continue $sm;
            }

          case 1:
            this.j8_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda).v3s = function ($this$intercept, body, completion) {
    var i = new defaultTransformers$slambda(completion);
    i.s44_1 = $this$intercept;
    i.t44_1 = body;
    return i;
  };
  function defaultTransformers$slambda_0(resultContinuation) {
    var i = new defaultTransformers$slambda(resultContinuation);
    var l = function ($this$intercept, body, $completion) {
      return i.u3s($this$intercept, body, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function defaultTransformers$slambda$slambda($body, $response, resultContinuation) {
    this.e45_1 = $body;
    this.f45_1 = $response;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda$slambda).f3y = function ($this$writer, $completion) {
    var tmp = this.g3y($this$writer, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(defaultTransformers$slambda$slambda).m9 = function (p1, $completion) {
    return this.f3y((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 5;
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.k8_1 = 4;
            this.k8_1 = 3;
            this.j8_1 = 2;
            suspendResult = copyTo(this.e45_1, this.g45_1.fw(), new Long(-1, 2147483647), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_0 = this;
            tmp_0.h45_1 = Unit_instance;
            this.k8_1 = 5;
            this.j8_1 = 6;
            continue $sm;
          case 3:
            this.k8_1 = 4;
            var tmp_1 = this.m8_1;
            if (tmp_1 instanceof CancellationException) {
              var cause = this.m8_1;
              var tmp_2 = this;
              cancel(this.f45_1, cause);
              throw cause;
            } else {
              var tmp_3 = this.m8_1;
              if (tmp_3 instanceof Error) {
                var cause_0 = this.m8_1;
                var tmp_4 = this;
                cancel_0(this.f45_1, 'Receive failed', cause_0);
                throw cause_0;
              } else {
                throw this.m8_1;
              }
            }

          case 4:
            this.k8_1 = 5;
            var t = this.m8_1;
            complete(this.f45_1);
            throw t;
          case 5:
            throw this.m8_1;
          case 6:
            this.k8_1 = 5;
            complete(this.f45_1);
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 5) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda$slambda).g3y = function ($this$writer, completion) {
    var i = new defaultTransformers$slambda$slambda(this.e45_1, this.f45_1, completion);
    i.g45_1 = $this$writer;
    return i;
  };
  function defaultTransformers$slambda$slambda_0($body, $response, resultContinuation) {
    var i = new defaultTransformers$slambda$slambda($body, $response, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.f3y($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function defaultTransformers$slambda$lambda($responseJobHolder) {
    return function (it) {
      $responseJobHolder.mr();
      return Unit_instance;
    };
  }
  function defaultTransformers$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda_1).o3t = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.p3t($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(defaultTransformers$slambda_1).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.o3t(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda_1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 11;
            this.s45_1 = this.r45_1.vd();
            this.t45_1 = this.r45_1.wd();
            var tmp_0 = this.t45_1;
            if (!isInterface(tmp_0, ByteReadChannel))
              return Unit_instance;
            this.u45_1 = this.q45_1.p3b_1.b3t();
            this.v45_1 = this.s45_1.h3c_1;
            if (this.v45_1.equals(getKClass(Unit))) {
              cancel_1(this.t45_1);
              this.j8_1 = 9;
              suspendResult = this.q45_1.t3a(new HttpResponseContainer(this.s45_1, Unit_instance), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (this.v45_1.equals(PrimitiveClasses_getInstance().ma())) {
                this.j8_1 = 7;
                suspendResult = this.t45_1.i2w(VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (this.v45_1.equals(getKClass(ByteReadPacket)) ? true : this.v45_1.equals(getKClass(Input))) {
                  this.j8_1 = 5;
                  suspendResult = this.t45_1.i2w(VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (this.v45_1.equals(PrimitiveClasses_getInstance().ua())) {
                    this.j8_1 = 3;
                    suspendResult = toByteArray(this.t45_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (this.v45_1.equals(getKClass(ByteReadChannel))) {
                      this.x45_1 = Job(this.u45_1.pj().w8(Key_instance));
                      var tmp_1 = this;
                      var tmp_2 = this.u45_1.pj();
                      var this_0 = writer(this.q45_1, tmp_2, VOID, defaultTransformers$slambda$slambda_0(this.t45_1, this.u45_1, null));
                      this_0.rk(defaultTransformers$slambda$lambda(this.x45_1));
                      tmp_1.y45_1 = this_0.fw();
                      this.j8_1 = 2;
                      suspendResult = this.q45_1.t3a(new HttpResponseContainer(this.s45_1, this.y45_1), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      if (this.v45_1.equals(getKClass(HttpStatusCode))) {
                        cancel_1(this.t45_1);
                        this.j8_1 = 1;
                        suspendResult = this.q45_1.t3a(new HttpResponseContainer(this.s45_1, this.u45_1.u3n()), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        this.w45_1 = null;
                        this.j8_1 = 10;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

          case 1:
            this.w45_1 = suspendResult;
            this.j8_1 = 10;
            continue $sm;
          case 2:
            this.w45_1 = suspendResult;
            this.j8_1 = 10;
            continue $sm;
          case 3:
            this.z45_1 = suspendResult;
            this.a46_1 = contentLength(this.u45_1);
            this.b46_1 = (!PlatformUtils_getInstance().e38_1 && this.u45_1.p3i().w2i(HttpHeaders_getInstance().z3e_1) == null);
            this.c46_1 = !this.q45_1.p3b_1.j3w().i3x().equals(Companion_getInstance_1().v3i_1);
            if (this.b46_1 && this.c46_1 && !(this.a46_1 == null) && this.a46_1.a1(new Long(0, 0)) > 0) {
              if (!(this.z45_1.length === this.a46_1.c3())) {
                var message = 'Expected ' + toString_0(this.a46_1) + ', actual ' + this.z45_1.length;
                throw IllegalStateException_init_$Create$(toString(message));
              }
            }

            this.j8_1 = 4;
            suspendResult = this.q45_1.t3a(new HttpResponseContainer(this.s45_1, this.z45_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.w45_1 = suspendResult;
            this.j8_1 = 10;
            continue $sm;
          case 5:
            this.d46_1 = suspendResult;
            this.e46_1 = new HttpResponseContainer(this.s45_1, this.d46_1);
            this.j8_1 = 6;
            suspendResult = this.q45_1.t3a(this.e46_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.w45_1 = suspendResult;
            this.j8_1 = 10;
            continue $sm;
          case 7:
            this.f46_1 = suspendResult;
            this.g46_1 = this.f46_1.o30();
            this.h46_1 = toInt(this.g46_1);
            this.i46_1 = new HttpResponseContainer(this.s45_1, this.h46_1);
            this.j8_1 = 8;
            suspendResult = this.q45_1.t3a(this.i46_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.w45_1 = suspendResult;
            this.j8_1 = 10;
            continue $sm;
          case 9:
            this.w45_1 = suspendResult;
            this.j8_1 = 10;
            continue $sm;
          case 10:
            var result = this.w45_1;
            if (!(result == null)) {
              get_LOGGER_1().m3c('Transformed with default transformers response body ' + ('for ' + this.q45_1.p3b_1.j3w().m3w().toString() + ' to ' + toString(this.s45_1.h3c_1)));
            }

            return Unit_instance;
          case 11:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 11) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda_1).p3t = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new defaultTransformers$slambda_1(completion);
    i.q45_1 = $this$intercept;
    i.r45_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function defaultTransformers$slambda_2(resultContinuation) {
    var i = new defaultTransformers$slambda_1(resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.o3t($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  var properties_initialized_DefaultTransform_kt_ossax9;
  function _init_properties_DefaultTransform_kt__20knxx() {
    if (!properties_initialized_DefaultTransform_kt_ossax9) {
      properties_initialized_DefaultTransform_kt_ossax9 = true;
      LOGGER_1 = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
    }
  }
  function get_LOGGER_2() {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return LOGGER_2;
  }
  var LOGGER_2;
  function get_ExpectSuccessAttributeKey() {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return ExpectSuccessAttributeKey;
  }
  var ExpectSuccessAttributeKey;
  function HttpCallValidator$Companion$install$slambda$lambda($plugin) {
    return function () {
      return $plugin.l46_1;
    };
  }
  function HttpCallValidator$Companion$install$slambda($plugin, resultContinuation) {
    this.u46_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$Companion$install$slambda).u3s = function ($this$intercept, it, $completion) {
    var tmp = this.v3s($this$intercept, it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpCallValidator$Companion$install$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$Companion$install$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 5;
            this.k8_1 = 3;
            var tmp_0 = get_ExpectSuccessAttributeKey();
            this.v46_1.p3b_1.f3u_1.u34(tmp_0, HttpCallValidator$Companion$install$slambda$lambda(this.u46_1));
            this.j8_1 = 1;
            suspendResult = this.v46_1.t3a(this.w46_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.k8_1 = 5;
            this.j8_1 = 2;
            continue $sm;
          case 2:
            this.k8_1 = 5;
            return Unit_instance;
          case 3:
            this.k8_1 = 5;
            var tmp_1 = this.m8_1;
            if (tmp_1 instanceof Error) {
              this.x46_1 = this.m8_1;
              this.y46_1 = unwrapCancellationException(this.x46_1);
              this.j8_1 = 4;
              suspendResult = processException(this.u46_1, this.y46_1, HttpRequest(this.v46_1.p3b_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 4:
            throw this.y46_1;
          case 5:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 5) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$Companion$install$slambda).v3s = function ($this$intercept, it, completion) {
    var i = new HttpCallValidator$Companion$install$slambda(this.u46_1, completion);
    i.v46_1 = $this$intercept;
    i.w46_1 = it;
    return i;
  };
  function HttpCallValidator$Companion$install$slambda_0($plugin, resultContinuation) {
    var i = new HttpCallValidator$Companion$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.u3s($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpCallValidator$Companion$install$slambda_1($plugin, resultContinuation) {
    this.h47_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$Companion$install$slambda_1).o3t = function ($this$intercept, container, $completion) {
    var tmp = this.p3t($this$intercept, container, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpCallValidator$Companion$install$slambda_1).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.o3t(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 5;
            this.k8_1 = 3;
            this.j8_1 = 1;
            suspendResult = this.i47_1.t3a(this.j47_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.k8_1 = 5;
            this.j8_1 = 2;
            continue $sm;
          case 2:
            this.k8_1 = 5;
            return Unit_instance;
          case 3:
            this.k8_1 = 5;
            var tmp_0 = this.m8_1;
            if (tmp_0 instanceof Error) {
              this.k47_1 = this.m8_1;
              this.l47_1 = unwrapCancellationException(this.k47_1);
              this.j8_1 = 4;
              suspendResult = processException(this.h47_1, this.l47_1, this.i47_1.p3b_1.j3w(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 4:
            throw this.l47_1;
          case 5:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 5) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_1).p3t = function ($this$intercept, container, completion) {
    var i = new HttpCallValidator$Companion$install$slambda_1(this.h47_1, completion);
    i.i47_1 = $this$intercept;
    i.j47_1 = container;
    return i;
  };
  function HttpCallValidator$Companion$install$slambda_2($plugin, resultContinuation) {
    var i = new HttpCallValidator$Companion$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, container, $completion) {
      return i.o3t($this$intercept, container, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpCallValidator$Companion$install$slambda_3($plugin, resultContinuation) {
    this.u47_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$Companion$install$slambda_3).y47 = function ($this$intercept, request, $completion) {
    var tmp = this.z47($this$intercept, request, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpCallValidator$Companion$install$slambda_3).xg = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.y47(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_3).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            this.j8_1 = 1;
            suspendResult = this.v47_1.a48(this.w47_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x47_1 = suspendResult;
            this.j8_1 = 2;
            suspendResult = validateResponse(this.u47_1, this.x47_1.b3t(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return this.x47_1;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_3).z47 = function ($this$intercept, request, completion) {
    var i = new HttpCallValidator$Companion$install$slambda_3(this.u47_1, completion);
    i.v47_1 = $this$intercept;
    i.w47_1 = request;
    return i;
  };
  function HttpCallValidator$Companion$install$slambda_4($plugin, resultContinuation) {
    var i = new HttpCallValidator$Companion$install$slambda_3($plugin, resultContinuation);
    var l = function ($this$intercept, request, $completion) {
      return i.y47($this$intercept, request, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function validateResponse($this, response, $completion) {
    var tmp = new $validateResponseCOROUTINE$5($this, response, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function processException($this, cause, request, $completion) {
    var tmp = new $processExceptionCOROUTINE$6($this, cause, request, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function Config() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.y43_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.z43_1 = ArrayList_init_$Create$();
    this.a44_1 = true;
  }
  protoOf(Config).e49 = function (block) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.z43_1;
    var element = new RequestExceptionHandlerWrapper(block);
    this_0.e(element);
  };
  protoOf(Config).b44 = function (block) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.y43_1.e(block);
  };
  function Companion_1() {
    Companion_instance_2 = this;
    this.f49_1 = new AttributeKey('HttpResponseValidator');
  }
  protoOf(Companion_1).u = function () {
    return this.f49_1;
  };
  protoOf(Companion_1).g49 = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var config = this_0;
    return new HttpCallValidator(reversed(config.y43_1), reversed(config.z43_1), config.a44_1);
  };
  protoOf(Companion_1).f3v = function (block) {
    return this.g49(block);
  };
  protoOf(Companion_1).h49 = function (plugin_0, scope) {
    var tmp = Phases_getInstance().w40_1;
    scope.a3s_1.t3b(tmp, HttpCallValidator$Companion$install$slambda_0(plugin_0, null));
    var BeforeReceive = new PipelinePhase('BeforeReceive');
    scope.b3s_1.s3b(Phases_getInstance_1().y3u_1, BeforeReceive);
    scope.b3s_1.t3b(BeforeReceive, HttpCallValidator$Companion$install$slambda_2(plugin_0, null));
    var tmp_0 = plugin(scope, Plugin_getInstance_4());
    tmp_0.k49(HttpCallValidator$Companion$install$slambda_4(plugin_0, null));
  };
  protoOf(Companion_1).g3v = function (plugin, scope) {
    return this.h49(plugin instanceof HttpCallValidator ? plugin : THROW_CCE(), scope);
  };
  var Companion_instance_2;
  function Companion_getInstance_8() {
    if (Companion_instance_2 == null)
      new Companion_1();
    return Companion_instance_2;
  }
  function $validateResponseCOROUTINE$5(_this__u8e3s4, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j48_1 = _this__u8e3s4;
    this.k48_1 = response;
  }
  protoOf($validateResponseCOROUTINE$5).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            get_LOGGER_2().m3c('Validating response for request ' + this.k48_1.h3x().j3w().m3w().toString());
            var tmp_0 = this;
            tmp_0.l48_1 = this.j48_1.j46_1;
            this.m48_1 = this.l48_1.g();
            this.j8_1 = 1;
            continue $sm;
          case 1:
            if (!this.m48_1.h()) {
              this.j8_1 = 3;
              continue $sm;
            }

            this.n48_1 = this.m48_1.i();
            this.j8_1 = 2;
            suspendResult = this.n48_1(this.k48_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.j8_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 4) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function $processExceptionCOROUTINE$6(_this__u8e3s4, cause, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w48_1 = _this__u8e3s4;
    this.x48_1 = cause;
    this.y48_1 = request;
  }
  protoOf($processExceptionCOROUTINE$6).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 6;
            get_LOGGER_2().m3c('Processing exception ' + this.x48_1.toString() + ' for request ' + this.y48_1.m3w().toString());
            var tmp_0 = this;
            tmp_0.z48_1 = this.w48_1.k46_1;
            this.a49_1 = this.z48_1.g();
            this.j8_1 = 1;
            continue $sm;
          case 1:
            if (!this.a49_1.h()) {
              this.j8_1 = 5;
              continue $sm;
            }

            this.b49_1 = this.a49_1.i();
            var tmp_1 = this;
            tmp_1.c49_1 = this.b49_1;
            this.d49_1 = this.c49_1;
            var tmp_2 = this.d49_1;
            if (tmp_2 instanceof ExceptionHandlerWrapper) {
              this.j8_1 = 3;
              suspendResult = this.c49_1.m49_1(this.x48_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_3 = this.d49_1;
              if (tmp_3 instanceof RequestExceptionHandlerWrapper) {
                this.j8_1 = 2;
                suspendResult = this.c49_1.l49_1(this.x48_1, this.y48_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.j8_1 = 4;
                continue $sm;
              }
            }

          case 2:
            this.j8_1 = 4;
            continue $sm;
          case 3:
            this.j8_1 = 4;
            continue $sm;
          case 4:
            this.j8_1 = 1;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 6) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function HttpCallValidator(responseValidators, callExceptionHandlers, expectSuccess) {
    Companion_getInstance_8();
    this.j46_1 = responseValidators;
    this.k46_1 = callExceptionHandlers;
    this.l46_1 = expectSuccess;
  }
  function ExceptionHandlerWrapper() {
  }
  function RequestExceptionHandlerWrapper(handler) {
    this.l49_1 = handler;
  }
  function HttpRequest(builder) {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return new HttpRequest$1(builder);
  }
  function HttpResponseValidator(_this__u8e3s4, block) {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    _this__u8e3s4.h3v(Companion_getInstance_8(), block);
  }
  function HttpRequest$1($builder) {
    this.r49_1 = $builder;
    this.n49_1 = $builder.b3u_1;
    this.o49_1 = $builder.a3u_1.b21();
    this.p49_1 = $builder.f3u_1;
    this.q49_1 = $builder.c3u_1.b21();
  }
  protoOf(HttpRequest$1).h3x = function () {
    var message = 'Call is not initialized';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(HttpRequest$1).i3x = function () {
    return this.n49_1;
  };
  protoOf(HttpRequest$1).m3w = function () {
    return this.o49_1;
  };
  protoOf(HttpRequest$1).p2i = function () {
    return this.p49_1;
  };
  protoOf(HttpRequest$1).p3i = function () {
    return this.q49_1;
  };
  var properties_initialized_HttpCallValidator_kt_xrx49w;
  function _init_properties_HttpCallValidator_kt__r6yh2y() {
    if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
      properties_initialized_HttpCallValidator_kt_xrx49w = true;
      LOGGER_2 = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
      ExpectSuccessAttributeKey = new AttributeKey('ExpectSuccessAttributeKey');
    }
  }
  function get_PLUGIN_INSTALLED_LIST() {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    return PLUGIN_INSTALLED_LIST;
  }
  var PLUGIN_INSTALLED_LIST;
  function plugin(_this__u8e3s4, plugin) {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    var tmp0_elvis_lhs = pluginOrNull(_this__u8e3s4, plugin);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('Plugin ' + toString(plugin) + ' is not installed. Consider using `install(' + plugin.u().toString() + ')` in client config first.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function HttpClientPlugin() {
  }
  function pluginOrNull(_this__u8e3s4, plugin) {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    var tmp0_safe_receiver = _this__u8e3s4.e3s_1.q34(get_PLUGIN_INSTALLED_LIST());
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q34(plugin.u());
  }
  var properties_initialized_HttpClientPlugin_kt_p98320;
  function _init_properties_HttpClientPlugin_kt__cypu1m() {
    if (!properties_initialized_HttpClientPlugin_kt_p98320) {
      properties_initialized_HttpClientPlugin_kt_p98320 = true;
      PLUGIN_INSTALLED_LIST = new AttributeKey('ApplicationPluginRegistry');
    }
  }
  function get_LOGGER_3() {
    _init_properties_HttpPlainText_kt__iy89z1();
    return LOGGER_3;
  }
  var LOGGER_3;
  function HttpPlainText$Plugin$install$slambda($plugin, resultContinuation) {
    this.a4a_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpPlainText$Plugin$install$slambda).u3s = function ($this$intercept, content, $completion) {
    var tmp = this.v3s($this$intercept, content, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpPlainText$Plugin$install$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpPlainText$Plugin$install$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.a4a_1.h4a(this.b4a_1.p3b_1);
            var tmp_0 = this.c4a_1;
            if (!(typeof tmp_0 === 'string'))
              return Unit_instance;
            this.d4a_1 = contentType(this.b4a_1.p3b_1);
            if (!(this.d4a_1 == null) && !(this.d4a_1.d3e_1 === Text_getInstance().t3d_1.d3e_1)) {
              return Unit_instance;
            }

            this.j8_1 = 1;
            suspendResult = this.b4a_1.t3a(wrapContent(this.a4a_1, this.b4a_1.p3b_1, this.c4a_1, this.d4a_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpPlainText$Plugin$install$slambda).v3s = function ($this$intercept, content, completion) {
    var i = new HttpPlainText$Plugin$install$slambda(this.a4a_1, completion);
    i.b4a_1 = $this$intercept;
    i.c4a_1 = content;
    return i;
  };
  function HttpPlainText$Plugin$install$slambda_0($plugin, resultContinuation) {
    var i = new HttpPlainText$Plugin$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.u3s($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpPlainText$Plugin$install$slambda_1($plugin, resultContinuation) {
    this.q4a_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpPlainText$Plugin$install$slambda_1).o3t = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.p3t($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpPlainText$Plugin$install$slambda_1).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.o3t(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpPlainText$Plugin$install$slambda_1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            this.t4a_1 = this.s4a_1.vd();
            this.u4a_1 = this.s4a_1.wd();
            var tmp_0;
            if (!this.t4a_1.h3c_1.equals(PrimitiveClasses_getInstance().qa())) {
              tmp_0 = true;
            } else {
              var tmp_1 = this.u4a_1;
              tmp_0 = !isInterface(tmp_1, ByteReadChannel);
            }

            if (tmp_0)
              return Unit_instance;
            this.j8_1 = 1;
            suspendResult = this.u4a_1.i2w(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.v4a_1 = suspendResult;
            this.w4a_1 = this.q4a_1.x4a(this.r4a_1.p3b_1, this.v4a_1);
            this.j8_1 = 2;
            suspendResult = this.r4a_1.t3a(new HttpResponseContainer(this.t4a_1, this.w4a_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpPlainText$Plugin$install$slambda_1).p3t = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new HttpPlainText$Plugin$install$slambda_1(this.q4a_1, completion);
    i.r4a_1 = $this$intercept;
    i.s4a_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function HttpPlainText$Plugin$install$slambda_2($plugin, resultContinuation) {
    var i = new HttpPlainText$Plugin$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.o3t($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Config_0() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.y4a_1 = LinkedHashSet_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.z4a_1 = LinkedHashMap_init_$Create$();
    this.a4b_1 = null;
    this.b4b_1 = Charsets_getInstance().w30_1;
  }
  function Plugin_1() {
    Plugin_instance_1 = this;
    this.c4b_1 = new AttributeKey('HttpPlainText');
  }
  protoOf(Plugin_1).u = function () {
    return this.c4b_1;
  };
  protoOf(Plugin_1).d4b = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_0();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var config = this_0;
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    return new HttpPlainText(config.y4a_1, config.z4a_1, config.a4b_1, config.b4b_1);
  };
  protoOf(Plugin_1).f3v = function (block) {
    return this.d4b(block);
  };
  protoOf(Plugin_1).e4b = function (plugin, scope) {
    var tmp = Phases_getInstance().z40_1;
    scope.a3s_1.t3b(tmp, HttpPlainText$Plugin$install$slambda_0(plugin, null));
    var tmp_0 = Phases_getInstance_1().a3v_1;
    scope.b3s_1.t3b(tmp_0, HttpPlainText$Plugin$install$slambda_2(plugin, null));
  };
  protoOf(Plugin_1).g3v = function (plugin, scope) {
    return this.e4b(plugin instanceof HttpPlainText ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_1;
  function Plugin_getInstance_1() {
    if (Plugin_instance_1 == null)
      new Plugin_1();
    return Plugin_instance_1;
  }
  function wrapContent($this, request, content, requestContentType) {
    var contentType = requestContentType == null ? Text_getInstance().t3d_1 : requestContentType;
    var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
    var charset_0 = tmp2_elvis_lhs == null ? $this.f4a_1 : tmp2_elvis_lhs;
    get_LOGGER_3().m3c('Sending request body to ' + request.a3u_1.toString() + ' as text/plain with charset ' + charset_0.toString());
    return new TextContent(content, withCharset(contentType, charset_0));
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.f4b_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).pb = function (a, b) {
    return this.f4b_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.pb(a, b);
  };
  function HttpPlainText$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
    var tmp = b.ud_1;
    // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
    var tmp$ret$1 = a.ud_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function HttpPlainText$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
    var tmp = get_name(a);
    // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
    var tmp$ret$1 = get_name(b);
    return compareValues(tmp, tmp$ret$1);
  }
  function HttpPlainText(charsets, charsetQuality, sendCharset, responseCharsetFallback) {
    Plugin_getInstance_1();
    this.e4a_1 = responseCharsetFallback;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = toList(charsetQuality);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = HttpPlainText$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
    var withQuality = sortedWith(this_0, tmp$ret$0);
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = charsets.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
      if (!charsetQuality.w1(element)) {
        destination.e(element);
      }
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = HttpPlainText$lambda_0;
    var tmp$ret$5 = new sam$kotlin_Comparator$0(tmp_0);
    var withoutQuality = sortedWith(destination, tmp$ret$5);
    var tmp_1 = this;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = withoutQuality.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.o7(',');
      }
      this_1.o7(get_name(element_0));
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = withQuality.g();
    while (tmp0_iterator_1.h()) {
      var element_1 = tmp0_iterator_1.i();
      // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>.<anonymous>' call
      var charset = element_1.vd();
      var quality = element_1.wd();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.o7(',');
      }
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(0.0 <= quality ? quality <= 1.0 : false)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.math.roundToInt' call
      var this_2 = 100 * quality;
      var truncatedQuality = roundToInt(this_2) / 100.0;
      this_1.o7(get_name(charset) + ';q=' + truncatedQuality);
    }
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(this_1) === 0) {
      this_1.o7(get_name(this.e4a_1));
    }
    tmp_1.g4a_1 = this_1.toString();
    var tmp_2 = this;
    var tmp2_elvis_lhs = sendCharset == null ? firstOrNull(withoutQuality) : sendCharset;
    var tmp_3;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver = firstOrNull(withQuality);
      tmp_3 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.td_1;
    } else {
      tmp_3 = tmp2_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_3;
    tmp_2.f4a_1 = tmp3_elvis_lhs == null ? Charsets_getInstance().w30_1 : tmp3_elvis_lhs;
  }
  protoOf(HttpPlainText).x4a = function (call, body) {
    var tmp0_elvis_lhs = charset_0(call.b3t());
    var actualCharset = tmp0_elvis_lhs == null ? this.e4a_1 : tmp0_elvis_lhs;
    get_LOGGER_3().m3c('Reading response body for ' + call.j3w().m3w().toString() + ' as String with charset ' + actualCharset.toString());
    return readText(body, actualCharset);
  };
  protoOf(HttpPlainText).h4a = function (context) {
    if (!(context.c3u_1.w2i(HttpHeaders_getInstance().n3e_1) == null))
      return Unit_instance;
    get_LOGGER_3().m3c('Adding Accept-Charset=' + this.g4a_1 + ' to ' + context.a3u_1.toString());
    context.c3u_1.v38(HttpHeaders_getInstance().n3e_1, this.g4a_1);
  };
  var properties_initialized_HttpPlainText_kt_2nx4ox;
  function _init_properties_HttpPlainText_kt__iy89z1() {
    if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
      properties_initialized_HttpPlainText_kt_2nx4ox = true;
      LOGGER_3 = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
    }
  }
  function get_ALLOWED_FOR_REDIRECT() {
    _init_properties_HttpRedirect_kt__ure7fo();
    return ALLOWED_FOR_REDIRECT;
  }
  var ALLOWED_FOR_REDIRECT;
  function get_LOGGER_4() {
    _init_properties_HttpRedirect_kt__ure7fo();
    return LOGGER_4;
  }
  var LOGGER_4;
  function handleCall(_this__u8e3s4, $this, context, origin, allowHttpsDowngrade, client, $completion) {
    var tmp = new $handleCallCOROUTINE$7($this, _this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function HttpRedirect$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.h4c_1 = $plugin;
    this.i4c_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRedirect$Plugin$install$slambda).y47 = function ($this$intercept, context, $completion) {
    var tmp = this.z47($this$intercept, context, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpRedirect$Plugin$install$slambda).xg = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.y47(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpRedirect$Plugin$install$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            this.j8_1 = 1;
            suspendResult = this.j4c_1.a48(this.k4c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.l4c_1 = suspendResult;
            if (this.h4c_1.m4c_1 && !get_ALLOWED_FOR_REDIRECT().r(this.l4c_1.j3w().i3x())) {
              return this.l4c_1;
            }

            this.j8_1 = 2;
            suspendResult = handleCall(this.j4c_1, Plugin_getInstance_2(), this.k4c_1, this.l4c_1, this.h4c_1.n4c_1, this.i4c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpRedirect$Plugin$install$slambda).z47 = function ($this$intercept, context, completion) {
    var i = new HttpRedirect$Plugin$install$slambda(this.h4c_1, this.i4c_1, completion);
    i.j4c_1 = $this$intercept;
    i.k4c_1 = context;
    return i;
  };
  function HttpRedirect$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new HttpRedirect$Plugin$install$slambda($plugin, $scope, resultContinuation);
    var l = function ($this$intercept, context, $completion) {
      return i.y47($this$intercept, context, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $handleCallCOROUTINE$7(_this__u8e3s4, _this__u8e3s4_0, context, origin, allowHttpsDowngrade, client, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o4b_1 = _this__u8e3s4;
    this.p4b_1 = _this__u8e3s4_0;
    this.q4b_1 = context;
    this.r4b_1 = origin;
    this.s4b_1 = allowHttpsDowngrade;
    this.t4b_1 = client;
  }
  protoOf($handleCallCOROUTINE$7).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            if (!isRedirect(this.r4b_1.b3t().u3n()))
              return this.r4b_1;
            this.u4b_1 = this.r4b_1;
            this.v4b_1 = this.q4b_1;
            this.w4b_1 = this.r4b_1.j3w().m3w().c3m_1;
            this.x4b_1 = get_authority(this.r4b_1.j3w().m3w());
            this.j8_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.j8_1 = 4;
              continue $sm;
            }

            this.t4b_1.g3s_1.j3o(this.o4b_1.p4c_1, this.u4b_1.b3t());
            this.y4b_1 = this.u4b_1.b3t().p3i().w2i(HttpHeaders_getInstance().a3g_1);
            get_LOGGER_4().m3c('Received redirect response to ' + this.y4b_1 + ' for request ' + this.q4b_1.a3u_1.toString());
            var tmp_0 = this;
            var this_0 = new HttpRequestBuilder();
            this_0.x3z(this.v4b_1);
            this_0.a3u_1.z3l_1.s1();
            var tmp0_safe_receiver = this.y4b_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              takeFrom_0(this_0.a3u_1, tmp0_safe_receiver);
            }

            if (!this.s4b_1 && isSecure(this.w4b_1) && !isSecure(this_0.a3u_1.q3l_1)) {
              get_LOGGER_4().m3c('Can not redirect ' + this.q4b_1.a3u_1.toString() + ' because of security downgrade');
              return this.u4b_1;
            }

            if (!(this.x4b_1 === get_authority_0(this_0.a3u_1))) {
              this_0.c3u_1.z38(HttpHeaders_getInstance().v3e_1);
              get_LOGGER_4().m3c('Removing Authorization header from redirect for ' + this.q4b_1.a3u_1.toString());
            }

            tmp_0.v4b_1 = this_0;
            this.j8_1 = 2;
            suspendResult = this.p4b_1.a48(this.v4b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.u4b_1 = suspendResult;
            if (!isRedirect(this.u4b_1.b3t().u3n()))
              return this.u4b_1;
            this.j8_1 = 1;
            continue $sm;
          case 3:
            throw this.m8_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function Config_1() {
    this.q4c_1 = true;
    this.r4c_1 = false;
  }
  function Plugin_2() {
    Plugin_instance_2 = this;
    this.o4c_1 = new AttributeKey('HttpRedirect');
    this.p4c_1 = new EventDefinition();
  }
  protoOf(Plugin_2).u = function () {
    return this.o4c_1;
  };
  protoOf(Plugin_2).s4c = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_1();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var config = this_0;
    return new HttpRedirect(config.q4c_1, config.r4c_1);
  };
  protoOf(Plugin_2).f3v = function (block) {
    return this.s4c(block);
  };
  protoOf(Plugin_2).t4c = function (plugin_0, scope) {
    var tmp = plugin(scope, Plugin_getInstance_4());
    tmp.k49(HttpRedirect$Plugin$install$slambda_0(plugin_0, scope, null));
  };
  protoOf(Plugin_2).g3v = function (plugin, scope) {
    return this.t4c(plugin instanceof HttpRedirect ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_2;
  function Plugin_getInstance_2() {
    if (Plugin_instance_2 == null)
      new Plugin_2();
    return Plugin_instance_2;
  }
  function HttpRedirect(checkHttpMethod, allowHttpsDowngrade) {
    Plugin_getInstance_2();
    this.m4c_1 = checkHttpMethod;
    this.n4c_1 = allowHttpsDowngrade;
  }
  function isRedirect(_this__u8e3s4) {
    _init_properties_HttpRedirect_kt__ure7fo();
    var tmp0_subject = _this__u8e3s4.k3l_1;
    return ((((tmp0_subject === Companion_getInstance_2().t3j_1.k3l_1 ? true : tmp0_subject === Companion_getInstance_2().u3j_1.k3l_1) ? true : tmp0_subject === Companion_getInstance_2().z3j_1.k3l_1) ? true : tmp0_subject === Companion_getInstance_2().a3k_1.k3l_1) ? true : tmp0_subject === Companion_getInstance_2().v3j_1.k3l_1) ? true : false;
  }
  var properties_initialized_HttpRedirect_kt_klj746;
  function _init_properties_HttpRedirect_kt__ure7fo() {
    if (!properties_initialized_HttpRedirect_kt_klj746) {
      properties_initialized_HttpRedirect_kt_klj746 = true;
      ALLOWED_FOR_REDIRECT = setOf_0([Companion_getInstance_1().q3i_1, Companion_getInstance_1().v3i_1]);
      LOGGER_4 = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    }
  }
  function get_LOGGER_5() {
    _init_properties_HttpRequestLifecycle_kt__jgkmfx();
    return LOGGER_5;
  }
  var LOGGER_5;
  function HttpRequestLifecycle$Plugin$install$slambda($scope, resultContinuation) {
    this.c4d_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).u3s = function ($this$intercept, it, $completion) {
    var tmp = this.v3s($this$intercept, it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 6;
            this.f4d_1 = SupervisorJob(this.d4d_1.p3b_1.e3u_1);
            attachToClientEngineJob(this.f4d_1, ensureNotNull(this.c4d_1.z3r_1.w8(Key_instance)));
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.k8_1 = 4;
            this.k8_1 = 3;
            this.d4d_1.p3b_1.e3u_1 = this.f4d_1;
            this.j8_1 = 2;
            suspendResult = this.d4d_1.u3a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_0 = this;
            tmp_0.g4d_1 = Unit_instance;
            this.k8_1 = 6;
            this.j8_1 = 5;
            continue $sm;
          case 3:
            this.k8_1 = 4;
            var tmp_1 = this.m8_1;
            if (tmp_1 instanceof Error) {
              var cause = this.m8_1;
              var tmp_2 = this;
              this.f4d_1.lr(cause);
              throw cause;
            } else {
              throw this.m8_1;
            }

          case 4:
            this.k8_1 = 6;
            var t = this.m8_1;
            this.f4d_1.mr();
            throw t;
          case 5:
            this.k8_1 = 6;
            this.f4d_1.mr();
            return Unit_instance;
          case 6:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 6) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).v3s = function ($this$intercept, it, completion) {
    var i = new HttpRequestLifecycle$Plugin$install$slambda(this.c4d_1, completion);
    i.d4d_1 = $this$intercept;
    i.e4d_1 = it;
    return i;
  };
  function HttpRequestLifecycle$Plugin$install$slambda_0($scope, resultContinuation) {
    var i = new HttpRequestLifecycle$Plugin$install$slambda($scope, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.u3s($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Plugin_3() {
    Plugin_instance_3 = this;
    this.h4d_1 = new AttributeKey('RequestLifecycle');
  }
  protoOf(Plugin_3).u = function () {
    return this.h4d_1;
  };
  protoOf(Plugin_3).f41 = function (block) {
    return new HttpRequestLifecycle();
  };
  protoOf(Plugin_3).f3v = function (block) {
    return this.f41(block);
  };
  protoOf(Plugin_3).i4d = function (plugin, scope) {
    var tmp = Phases_getInstance().w40_1;
    scope.a3s_1.t3b(tmp, HttpRequestLifecycle$Plugin$install$slambda_0(scope, null));
  };
  protoOf(Plugin_3).g3v = function (plugin, scope) {
    return this.i4d(plugin instanceof HttpRequestLifecycle ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_3;
  function Plugin_getInstance_3() {
    if (Plugin_instance_3 == null)
      new Plugin_3();
    return Plugin_instance_3;
  }
  function HttpRequestLifecycle() {
    Plugin_getInstance_3();
  }
  function attachToClientEngineJob(requestJob, clientEngineJob) {
    _init_properties_HttpRequestLifecycle_kt__jgkmfx();
    var handler = clientEngineJob.rk(attachToClientEngineJob$lambda(requestJob));
    requestJob.rk(attachToClientEngineJob$lambda_0(handler));
  }
  function attachToClientEngineJob$lambda($requestJob) {
    return function (cause) {
      var tmp;
      if (!(cause == null)) {
        get_LOGGER_5().m3c('Cancelling request because engine Job failed with error: ' + toString_0(cause));
        cancel_2($requestJob, 'Engine failed', cause);
        tmp = Unit_instance;
      } else {
        get_LOGGER_5().m3c('Cancelling request because engine Job completed');
        $requestJob.mr();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function attachToClientEngineJob$lambda_0($handler) {
    return function (it) {
      $handler.im();
      return Unit_instance;
    };
  }
  var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
  function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
    if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
      properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
      LOGGER_5 = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestLifecycle');
    }
  }
  function HttpSend$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.r4d_1 = $plugin;
    this.s4d_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpSend$Plugin$install$slambda).u3s = function ($this$intercept, content, $completion) {
    var tmp = this.v3s($this$intercept, content, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpSend$Plugin$install$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpSend$Plugin$install$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            var tmp_0 = this.u4d_1;
            if (!(tmp_0 instanceof OutgoingContent)) {
              var message = trimMargin('\n|Fail to prepare request body for sending. \n|The body type is: ' + toString(getKClassFromExpression(this.u4d_1)) + ', with Content-Type: ' + toString_0(contentType(this.t4d_1.p3b_1)) + '.\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.');
              throw IllegalStateException_init_$Create$(toString(message));
            }

            var this_0 = this.t4d_1.p3b_1;
            var body = this.u4d_1;
            if (body == null) {
              this_0.d3u_1 = NullBody_instance;
              var tmp_1 = JsType_instance;
              var tmp_2 = getKClass(OutgoingContent);
              var tmp_3;
              try {
                tmp_3 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_4 = null;
                } else {
                  throw $p;
                }
                tmp_3 = tmp_4;
              }
              this_0.y3z(typeInfoImpl(tmp_1, tmp_2, tmp_3));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.d3u_1 = body;
                this_0.y3z(null);
              } else {
                this_0.d3u_1 = body;
                var tmp_5 = JsType_instance;
                var tmp_6 = getKClass(OutgoingContent);
                var tmp_7;
                try {
                  tmp_7 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
                } catch ($p) {
                  var tmp_8;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_8 = null;
                  } else {
                    throw $p;
                  }
                  tmp_7 = tmp_8;
                }
                this_0.y3z(typeInfoImpl(tmp_5, tmp_6, tmp_7));
              }
            }

            this.v4d_1 = new DefaultSender(this.r4d_1.i49_1, this.s4d_1);
            this.w4d_1 = this.v4d_1;
            var tmp0_iterator = downTo(get_lastIndex(this.r4d_1.j49_1), 0).g();
            while (tmp0_iterator.h()) {
              var element = tmp0_iterator.i();
              var interceptor = this.r4d_1.j49_1.p(element);
              this.w4d_1 = new InterceptedSender(interceptor, this.w4d_1);
            }

            this.j8_1 = 1;
            suspendResult = this.w4d_1.a48(this.t4d_1.p3b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x4d_1 = suspendResult;
            this.j8_1 = 2;
            suspendResult = this.t4d_1.t3a(this.x4d_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpSend$Plugin$install$slambda).v3s = function ($this$intercept, content, completion) {
    var i = new HttpSend$Plugin$install$slambda(this.r4d_1, this.s4d_1, completion);
    i.t4d_1 = $this$intercept;
    i.u4d_1 = content;
    return i;
  };
  function HttpSend$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new HttpSend$Plugin$install$slambda($plugin, $scope, resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.u3s($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $executeCOROUTINE$8(_this__u8e3s4, requestBuilder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g4e_1 = _this__u8e3s4;
    this.h4e_1 = requestBuilder;
  }
  protoOf($executeCOROUTINE$8).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            var tmp0_safe_receiver = this.g4e_1.l4e_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              cancel(tmp0_safe_receiver);
            }

            if (this.g4e_1.k4e_1 >= this.g4e_1.i4e_1) {
              throw new SendCountExceedException('Max send count ' + this.g4e_1.i4e_1 + ' exceeded. Consider increasing the property ' + 'maxSendCount if more is required.');
            }

            var tmp1_this = this.g4e_1;
            tmp1_this.k4e_1 = tmp1_this.k4e_1 + 1 | 0;
            this.j8_1 = 1;
            suspendResult = this.g4e_1.j4e_1.c3s_1.o3b(this.h4e_1, this.h4e_1.d3u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var sendResult = suspendResult;
            var tmp3_elvis_lhs = sendResult instanceof HttpClientCall ? sendResult : null;
            var tmp_0;
            if (tmp3_elvis_lhs == null) {
              var message = 'Failed to execute send pipeline. Expected [HttpClientCall], but received ' + toString(sendResult);
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              tmp_0 = tmp3_elvis_lhs;
            }

            var call = tmp_0;
            this.g4e_1.l4e_1 = call;
            return call;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function Config_2() {
    this.m4e_1 = 20;
  }
  function Plugin_4() {
    Plugin_instance_4 = this;
    this.n4e_1 = new AttributeKey('HttpSend');
  }
  protoOf(Plugin_4).u = function () {
    return this.n4e_1;
  };
  protoOf(Plugin_4).o4e = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_2();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var config = this_0;
    return new HttpSend(config.m4e_1);
  };
  protoOf(Plugin_4).f3v = function (block) {
    return this.o4e(block);
  };
  protoOf(Plugin_4).p4e = function (plugin, scope) {
    var tmp = Phases_getInstance().a41_1;
    scope.a3s_1.t3b(tmp, HttpSend$Plugin$install$slambda_0(plugin, scope, null));
  };
  protoOf(Plugin_4).g3v = function (plugin, scope) {
    return this.p4e(plugin instanceof HttpSend ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_4;
  function Plugin_getInstance_4() {
    if (Plugin_instance_4 == null)
      new Plugin_4();
    return Plugin_instance_4;
  }
  function InterceptedSender(interceptor, nextSender) {
    this.q4e_1 = interceptor;
    this.r4e_1 = nextSender;
  }
  protoOf(InterceptedSender).a48 = function (requestBuilder, $completion) {
    return this.q4e_1(this.r4e_1, requestBuilder, $completion);
  };
  function DefaultSender(maxSendCount, client) {
    this.i4e_1 = maxSendCount;
    this.j4e_1 = client;
    this.k4e_1 = 0;
    this.l4e_1 = null;
  }
  protoOf(DefaultSender).a48 = function (requestBuilder, $completion) {
    var tmp = new $executeCOROUTINE$8(this, requestBuilder, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  function HttpSend(maxSendCount) {
    Plugin_getInstance_4();
    maxSendCount = maxSendCount === VOID ? 20 : maxSendCount;
    this.i49_1 = maxSendCount;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.j49_1 = ArrayList_init_$Create$();
  }
  protoOf(HttpSend).k49 = function (block) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.j49_1.e(block);
  };
  function Sender() {
  }
  function SendCountExceedException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, SendCountExceedException);
  }
  function get_LOGGER_6() {
    _init_properties_HttpTimeout_kt__pucqrr();
    return LOGGER_6;
  }
  var LOGGER_6;
  function HttpTimeoutCapabilityConfiguration_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, $this) {
    requestTimeoutMillis = requestTimeoutMillis === VOID ? null : requestTimeoutMillis;
    connectTimeoutMillis = connectTimeoutMillis === VOID ? null : connectTimeoutMillis;
    socketTimeoutMillis = socketTimeoutMillis === VOID ? null : socketTimeoutMillis;
    HttpTimeoutCapabilityConfiguration.call($this);
    $this.v4e(requestTimeoutMillis);
    $this.w4e(connectTimeoutMillis);
    $this.x4e(socketTimeoutMillis);
    return $this;
  }
  function HttpTimeoutCapabilityConfiguration_init_$Create$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
    return HttpTimeoutCapabilityConfiguration_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, objectCreate(protoOf(HttpTimeoutCapabilityConfiguration)));
  }
  function checkTimeoutValue($this, value) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(value == null || value.a1(new Long(0, 0)) > 0)) {
      // Inline function 'io.ktor.client.plugins.HttpTimeoutCapabilityConfiguration.checkTimeoutValue.<anonymous>' call
      var message = 'Only positive timeout values are allowed, for infinite timeout use HttpTimeout.INFINITE_TIMEOUT_MS';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return value;
  }
  function Companion_2() {
    Companion_instance_3 = this;
    this.y4e_1 = new AttributeKey('TimeoutConfiguration');
  }
  var Companion_instance_3;
  function Companion_getInstance_9() {
    if (Companion_instance_3 == null)
      new Companion_2();
    return Companion_instance_3;
  }
  function HttpTimeout$Plugin$install$slambda$slambda($requestTimeout, $request, $executionContext, resultContinuation) {
    this.h4f_1 = $requestTimeout;
    this.i4f_1 = $request;
    this.j4f_1 = $executionContext;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = delay(this.h4f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var cause = HttpRequestTimeoutException_init_$Create$(this.i4f_1);
            get_LOGGER_6().m3c('Request timeout: ' + this.i4f_1.a3u_1.toString());
            cancel_2(this.j4f_1, ensureNotNull(cause.message), cause);
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).m17 = function ($this$launch, completion) {
    var i = new HttpTimeout$Plugin$install$slambda$slambda(this.h4f_1, this.i4f_1, this.j4f_1, completion);
    i.k4f_1 = $this$launch;
    return i;
  };
  function HttpTimeout$Plugin$install$slambda$slambda_0($requestTimeout, $request, $executionContext, resultContinuation) {
    var i = new HttpTimeout$Plugin$install$slambda$slambda($requestTimeout, $request, $executionContext, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function HttpTimeout$Plugin$install$slambda$lambda($killer) {
    return function (it) {
      $killer.yk();
      return Unit_instance;
    };
  }
  function HttpTimeout$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.t4f_1 = $plugin;
    this.u4f_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpTimeout$Plugin$install$slambda).y47 = function ($this$intercept, request, $completion) {
    var tmp = this.z47($this$intercept, request, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpTimeout$Plugin$install$slambda).xg = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.y47(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpTimeout$Plugin$install$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            this.x4f_1 = isWebsocket(this.w4f_1.a3u_1.q3l_1);
            var tmp_0;
            if (this.x4f_1) {
              tmp_0 = true;
            } else {
              var tmp_1 = this.w4f_1.d3u_1;
              tmp_0 = tmp_1 instanceof ClientUpgradeContent;
            }

            if (tmp_0) {
              this.j8_1 = 3;
              suspendResult = this.v4f_1.a48(this.w4f_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.j8_1 = 1;
              continue $sm;
            }

          case 1:
            this.y4f_1 = this.w4f_1.z4f(Plugin_getInstance_5());
            if (this.y4f_1 == null && hasNotNullTimeouts(this.t4f_1)) {
              this.y4f_1 = HttpTimeoutCapabilityConfiguration_init_$Create$();
              this.w4f_1.a4g(Plugin_getInstance_5(), this.y4f_1);
            }

            var tmp0_safe_receiver = this.y4f_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              l$ret$1: do {
                var tmp0_elvis_lhs = tmp0_safe_receiver.b4g();
                tmp0_safe_receiver.w4e(tmp0_elvis_lhs == null ? this.t4f_1.d4g_1 : tmp0_elvis_lhs);
                var tmp1_elvis_lhs = tmp0_safe_receiver.f4g();
                tmp0_safe_receiver.x4e(tmp1_elvis_lhs == null ? this.t4f_1.e4g_1 : tmp1_elvis_lhs);
                var tmp2_elvis_lhs = tmp0_safe_receiver.g4g();
                tmp0_safe_receiver.v4e(tmp2_elvis_lhs == null ? this.t4f_1.c4g_1 : tmp2_elvis_lhs);
                var tmp3_elvis_lhs = tmp0_safe_receiver.g4g();
                var requestTimeout = tmp3_elvis_lhs == null ? this.t4f_1.c4g_1 : tmp3_elvis_lhs;
                if (requestTimeout == null || equals(requestTimeout, new Long(-1, 2147483647))) {
                  break l$ret$1;
                }
                var executionContext = this.w4f_1.e3u_1;
                var killer = launch(this.u4f_1, VOID, VOID, HttpTimeout$Plugin$install$slambda$slambda_0(requestTimeout, this.w4f_1, executionContext, null));
                var tmp_2 = this.w4f_1.e3u_1;
                tmp_2.rk(HttpTimeout$Plugin$install$slambda$lambda(killer));
              }
               while (false);
            }

            this.j8_1 = 2;
            suspendResult = this.v4f_1.a48(this.w4f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            return suspendResult;
          case 4:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 4) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpTimeout$Plugin$install$slambda).z47 = function ($this$intercept, request, completion) {
    var i = new HttpTimeout$Plugin$install$slambda(this.t4f_1, this.u4f_1, completion);
    i.v4f_1 = $this$intercept;
    i.w4f_1 = request;
    return i;
  };
  function HttpTimeout$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new HttpTimeout$Plugin$install$slambda($plugin, $scope, resultContinuation);
    var l = function ($this$intercept, request, $completion) {
      return i.y47($this$intercept, request, $completion);
    };
    l.$arity = 2;
    return l;
  }
  protoOf(HttpTimeoutCapabilityConfiguration).v4e = function (value) {
    this.s4e_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutCapabilityConfiguration).g4g = function () {
    return this.s4e_1;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).w4e = function (value) {
    this.t4e_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutCapabilityConfiguration).b4g = function () {
    return this.t4e_1;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).x4e = function (value) {
    this.u4e_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutCapabilityConfiguration).f4g = function () {
    return this.u4e_1;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).h4g = function () {
    return new HttpTimeout(this.g4g(), this.b4g(), this.f4g());
  };
  protoOf(HttpTimeoutCapabilityConfiguration).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof HttpTimeoutCapabilityConfiguration))
      THROW_CCE();
    if (!equals(this.s4e_1, other.s4e_1))
      return false;
    if (!equals(this.t4e_1, other.t4e_1))
      return false;
    if (!equals(this.u4e_1, other.u4e_1))
      return false;
    return true;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).hashCode = function () {
    var tmp0_safe_receiver = this.s4e_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.t4e_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp4_safe_receiver = this.u4e_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.hashCode();
    result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    return result;
  };
  function HttpTimeoutCapabilityConfiguration() {
    Companion_getInstance_9();
    this.s4e_1 = new Long(0, 0);
    this.t4e_1 = new Long(0, 0);
    this.u4e_1 = new Long(0, 0);
  }
  function hasNotNullTimeouts($this) {
    return !($this.c4g_1 == null) || !($this.d4g_1 == null) || !($this.e4g_1 == null);
  }
  function Plugin_5() {
    Plugin_instance_5 = this;
    this.i4g_1 = new AttributeKey('TimeoutPlugin');
    this.j4g_1 = new Long(-1, 2147483647);
  }
  protoOf(Plugin_5).u = function () {
    return this.i4g_1;
  };
  protoOf(Plugin_5).k4g = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = HttpTimeoutCapabilityConfiguration_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    return this_0.h4g();
  };
  protoOf(Plugin_5).f3v = function (block) {
    return this.k4g(block);
  };
  protoOf(Plugin_5).l4g = function (plugin_0, scope) {
    var tmp = plugin(scope, Plugin_getInstance_4());
    tmp.k49(HttpTimeout$Plugin$install$slambda_0(plugin_0, scope, null));
  };
  protoOf(Plugin_5).g3v = function (plugin, scope) {
    return this.l4g(plugin instanceof HttpTimeout ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_5;
  function Plugin_getInstance_5() {
    if (Plugin_instance_5 == null)
      new Plugin_5();
    return Plugin_instance_5;
  }
  function HttpTimeout(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
    Plugin_getInstance_5();
    this.c4g_1 = requestTimeoutMillis;
    this.d4g_1 = connectTimeoutMillis;
    this.e4g_1 = socketTimeoutMillis;
  }
  function HttpRequestTimeoutException_init_$Init$(request, $this) {
    var tmp = request.a3u_1.f3n();
    var tmp0_safe_receiver = request.z4f(Plugin_getInstance_5());
    HttpRequestTimeoutException.call($this, tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g4g());
    return $this;
  }
  function HttpRequestTimeoutException_init_$Create$(request) {
    var tmp = HttpRequestTimeoutException_init_$Init$(request, objectCreate(protoOf(HttpRequestTimeoutException)));
    captureStack(tmp, HttpRequestTimeoutException_init_$Create$);
    return tmp;
  }
  function HttpRequestTimeoutException(url, timeoutMillis) {
    IOException_init_$Init$('Request timeout has expired [url=' + url + ', request_timeout=' + toString(timeoutMillis == null ? 'unknown' : timeoutMillis) + ' ms]', this);
    captureStack(this, HttpRequestTimeoutException);
  }
  var properties_initialized_HttpTimeout_kt_9oyjbd;
  function _init_properties_HttpTimeout_kt__pucqrr() {
    if (!properties_initialized_HttpTimeout_kt_9oyjbd) {
      properties_initialized_HttpTimeout_kt_9oyjbd = true;
      LOGGER_6 = KtorSimpleLogger('io.ktor.client.plugins.HttpTimeout');
    }
  }
  function wrapWithContent(_this__u8e3s4, content) {
    return new DelegatedCall(_this__u8e3s4.w3s_1, content, _this__u8e3s4);
  }
  function DelegatedCall(client, content, originCall) {
    HttpClientCall.call(this, client);
    this.y3s_1 = new DelegatedRequest(this, originCall.j3w());
    this.z3s_1 = new DelegatedResponse(this, content, originCall.b3t());
  }
  function DelegatedRequest(call, origin) {
    this.m4g_1 = call;
    this.n4g_1 = origin;
  }
  protoOf(DelegatedRequest).h3x = function () {
    return this.m4g_1;
  };
  protoOf(DelegatedRequest).p2i = function () {
    return this.n4g_1.p2i();
  };
  protoOf(DelegatedRequest).pj = function () {
    return this.n4g_1.pj();
  };
  protoOf(DelegatedRequest).p3i = function () {
    return this.n4g_1.p3i();
  };
  protoOf(DelegatedRequest).i3x = function () {
    return this.n4g_1.i3x();
  };
  protoOf(DelegatedRequest).m3w = function () {
    return this.n4g_1.m3w();
  };
  function DelegatedResponse(call, content, origin) {
    HttpResponse.call(this);
    this.o4g_1 = call;
    this.p4g_1 = content;
    this.q4g_1 = origin;
    this.r4g_1 = this.q4g_1.pj();
  }
  protoOf(DelegatedResponse).h3x = function () {
    return this.o4g_1;
  };
  protoOf(DelegatedResponse).k3w = function () {
    return this.p4g_1;
  };
  protoOf(DelegatedResponse).pj = function () {
    return this.r4g_1;
  };
  protoOf(DelegatedResponse).u3n = function () {
    return this.q4g_1.u3n();
  };
  protoOf(DelegatedResponse).s3x = function () {
    return this.q4g_1.s3x();
  };
  protoOf(DelegatedResponse).t3x = function () {
    return this.q4g_1.t3x();
  };
  protoOf(DelegatedResponse).u3x = function () {
    return this.q4g_1.u3x();
  };
  protoOf(DelegatedResponse).p3i = function () {
    return this.q4g_1.p3i();
  };
  function ResponseObserver$Config$responseHandler$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ResponseObserver$Config$responseHandler$slambda).w43 = function (it, $completion) {
    var tmp = this.x43(it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(ResponseObserver$Config$responseHandler$slambda).m9 = function (p1, $completion) {
    return this.w43(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ResponseObserver$Config$responseHandler$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        if (tmp === 0) {
          this.k8_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ResponseObserver$Config$responseHandler$slambda).x43 = function (it, completion) {
    var i = new ResponseObserver$Config$responseHandler$slambda(completion);
    i.a4h_1 = it;
    return i;
  };
  function ResponseObserver$Config$responseHandler$slambda_0(resultContinuation) {
    var i = new ResponseObserver$Config$responseHandler$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.w43(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ResponseObserver$Plugin$install$slambda$slambda($plugin, $sideResponse, resultContinuation) {
    this.j4h_1 = $plugin;
    this.k4h_1 = $sideResponse;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ResponseObserver$Plugin$install$slambda$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(ResponseObserver$Plugin$install$slambda$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ResponseObserver$Plugin$install$slambda$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 8;
            var tmp_0 = this;
            tmp_0.m4h_1 = this.l4h_1;
            this.k8_1 = 2;
            var tmp_1 = this;
            tmp_1.o4h_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.p4h_1 = this.m4h_1;
            this.j8_1 = 1;
            suspendResult = this.j4h_1.x4h_1(this.k4h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_3 = this;
            tmp_3.q4h_1 = Unit_instance;
            this.n4h_1 = _Result___init__impl__xyqfz8(this.q4h_1);
            this.k8_1 = 8;
            this.j8_1 = 3;
            continue $sm;
          case 2:
            this.k8_1 = 8;
            var tmp_4 = this.m8_1;
            if (tmp_4 instanceof Error) {
              this.r4h_1 = this.m8_1;
              var tmp_5 = this;
              var exception = this.r4h_1;
              tmp_5.n4h_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.j8_1 = 3;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 3:
            this.k8_1 = 8;
            this.s4h_1 = this.k4h_1.k3w();
            if (!this.s4h_1.o2q()) {
              var tmp_6 = this;
              tmp_6.t4h_1 = this.l4h_1;
              this.k8_1 = 5;
              var tmp_7 = this;
              tmp_7.v4h_1 = Companion_instance;
              var tmp_8 = this;
              tmp_8.w4h_1 = this.t4h_1;
              this.j8_1 = 4;
              suspendResult = discard(this.s4h_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.j8_1 = 7;
              continue $sm;
            }

          case 4:
            var value = suspendResult;
            this.u4h_1 = _Result___init__impl__xyqfz8(value);
            this.k8_1 = 8;
            this.j8_1 = 6;
            continue $sm;
          case 5:
            this.k8_1 = 8;
            var tmp_9 = this.m8_1;
            if (tmp_9 instanceof Error) {
              var e = this.m8_1;
              var tmp_10 = this;
              tmp_10.u4h_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.j8_1 = 6;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 6:
            this.k8_1 = 8;
            this.j8_1 = 7;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.m8_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.k8_1 === 8) {
          throw e_0;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(ResponseObserver$Plugin$install$slambda$slambda).m17 = function ($this$launch, completion) {
    var i = new ResponseObserver$Plugin$install$slambda$slambda(this.j4h_1, this.k4h_1, completion);
    i.l4h_1 = $this$launch;
    return i;
  };
  function ResponseObserver$Plugin$install$slambda$slambda_0($plugin, $sideResponse, resultContinuation) {
    var i = new ResponseObserver$Plugin$install$slambda$slambda($plugin, $sideResponse, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ResponseObserver$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.h4i_1 = $plugin;
    this.i4i_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ResponseObserver$Plugin$install$slambda).f42 = function ($this$intercept, response, $completion) {
    var tmp = this.g42($this$intercept, response, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(ResponseObserver$Plugin$install$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.f42(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ResponseObserver$Plugin$install$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            var tmp0_safe_receiver = this.h4i_1.y4h_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver(this.k4i_1.h3x())) === false)
              return Unit_instance;
            this.l4i_1 = split(this.k4i_1.k3w(), this.k4i_1);
            this.m4i_1 = this.l4i_1.vd();
            this.n4i_1 = this.l4i_1.wd();
            this.o4i_1 = wrapWithContent(this.k4i_1.h3x(), this.n4i_1).b3t();
            this.p4i_1 = wrapWithContent(this.k4i_1.h3x(), this.m4i_1).b3t();
            this.j8_1 = 1;
            suspendResult = getResponseObserverContext(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.q4i_1 = suspendResult;
            launch(this.i4i_1, this.q4i_1, VOID, ResponseObserver$Plugin$install$slambda$slambda_0(this.h4i_1, this.p4i_1, null));
            this.j8_1 = 2;
            suspendResult = this.j4i_1.t3a(this.o4i_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(ResponseObserver$Plugin$install$slambda).g42 = function ($this$intercept, response, completion) {
    var i = new ResponseObserver$Plugin$install$slambda(this.h4i_1, this.i4i_1, completion);
    i.j4i_1 = $this$intercept;
    i.k4i_1 = response;
    return i;
  };
  function ResponseObserver$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new ResponseObserver$Plugin$install$slambda($plugin, $scope, resultContinuation);
    var l = function ($this$intercept, response, $completion) {
      return i.f42($this$intercept, response, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Config_3() {
    var tmp = this;
    tmp.r4i_1 = ResponseObserver$Config$responseHandler$slambda_0(null);
    this.s4i_1 = null;
  }
  function Plugin_6() {
    Plugin_instance_6 = this;
    this.t4i_1 = new AttributeKey('BodyInterceptor');
  }
  protoOf(Plugin_6).u = function () {
    return this.t4i_1;
  };
  protoOf(Plugin_6).u4i = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_3();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var config = this_0;
    return new ResponseObserver(config.r4i_1, config.s4i_1);
  };
  protoOf(Plugin_6).f3v = function (block) {
    return this.u4i(block);
  };
  protoOf(Plugin_6).v4i = function (plugin, scope) {
    var tmp = Phases_getInstance_2().d41_1;
    scope.d3s_1.t3b(tmp, ResponseObserver$Plugin$install$slambda_0(plugin, scope, null));
  };
  protoOf(Plugin_6).g3v = function (plugin, scope) {
    return this.v4i(plugin instanceof ResponseObserver ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_6;
  function Plugin_getInstance_6() {
    if (Plugin_instance_6 == null)
      new Plugin_6();
    return Plugin_instance_6;
  }
  function ResponseObserver(responseHandler, filter) {
    Plugin_getInstance_6();
    filter = filter === VOID ? null : filter;
    this.x4h_1 = responseHandler;
    this.y4h_1 = filter;
  }
  function WebSocketCapability() {
  }
  protoOf(WebSocketCapability).toString = function () {
    return 'WebSocketCapability';
  };
  var WebSocketCapability_instance;
  function WebSocketCapability_getInstance() {
    return WebSocketCapability_instance;
  }
  function WebSocketException_init_$Init$(message, $this) {
    WebSocketException.call($this, message, null);
    return $this;
  }
  function WebSocketException_init_$Create$(message) {
    var tmp = WebSocketException_init_$Init$(message, objectCreate(protoOf(WebSocketException)));
    captureStack(tmp, WebSocketException_init_$Create$);
    return tmp;
  }
  function WebSocketException(message, cause) {
    IllegalStateException_init_$Init$_1(message, cause, this);
    captureStack(this, WebSocketException);
  }
  function ClientUpgradeContent() {
  }
  function DefaultHttpRequest(call, data) {
    this.w4i_1 = call;
    this.x4i_1 = data.z3y_1;
    this.y4i_1 = data.y3y_1;
    this.z4i_1 = data.b3z_1;
    this.a4j_1 = data.a3z_1;
    this.b4j_1 = data.d3z_1;
  }
  protoOf(DefaultHttpRequest).h3x = function () {
    return this.w4i_1;
  };
  protoOf(DefaultHttpRequest).pj = function () {
    return this.h3x().pj();
  };
  protoOf(DefaultHttpRequest).i3x = function () {
    return this.x4i_1;
  };
  protoOf(DefaultHttpRequest).m3w = function () {
    return this.y4i_1;
  };
  protoOf(DefaultHttpRequest).p3i = function () {
    return this.a4j_1;
  };
  protoOf(DefaultHttpRequest).p2i = function () {
    return this.b4j_1;
  };
  function HttpRequest_0() {
  }
  function Companion_3() {
  }
  var Companion_instance_4;
  function Companion_getInstance_10() {
    return Companion_instance_4;
  }
  function HttpRequestBuilder$setCapability$lambda() {
    // Inline function 'kotlin.collections.mutableMapOf' call
    return LinkedHashMap_init_$Create$();
  }
  function HttpRequestBuilder() {
    this.a3u_1 = new URLBuilder_0();
    this.b3u_1 = Companion_getInstance_1().q3i_1;
    this.c3u_1 = new HeadersBuilder();
    this.d3u_1 = EmptyContent_getInstance();
    this.e3u_1 = SupervisorJob();
    this.f3u_1 = AttributesJsFn(true);
  }
  protoOf(HttpRequestBuilder).p3i = function () {
    return this.c3u_1;
  };
  protoOf(HttpRequestBuilder).y3z = function (value) {
    if (!(value == null)) {
      this.f3u_1.s34(get_BodyTypeAttributeKey(), value);
    } else {
      this.f3u_1.t34(get_BodyTypeAttributeKey());
    }
  };
  protoOf(HttpRequestBuilder).c4j = function () {
    return this.f3u_1.q34(get_BodyTypeAttributeKey());
  };
  protoOf(HttpRequestBuilder).d4j = function (block) {
    return block(this.a3u_1, this.a3u_1);
  };
  protoOf(HttpRequestBuilder).b21 = function () {
    var tmp = this.a3u_1.b21();
    var tmp_0 = this.b3u_1;
    var tmp_1 = this.c3u_1.b21();
    var tmp_2 = this.d3u_1;
    var tmp0_elvis_lhs = tmp_2 instanceof OutgoingContent ? tmp_2 : null;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      var message = 'No request transformation found: ' + toString(this.d3u_1);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    return new HttpRequestData(tmp, tmp_0, tmp_1, tmp_3, this.e3u_1, this.f3u_1);
  };
  protoOf(HttpRequestBuilder).x3z = function (builder) {
    this.e3u_1 = builder.e3u_1;
    return this.e4j(builder);
  };
  protoOf(HttpRequestBuilder).e4j = function (builder) {
    this.b3u_1 = builder.b3u_1;
    this.d3u_1 = builder.d3u_1;
    this.y3z(builder.c4j());
    takeFrom(this.a3u_1, builder.a3u_1);
    this.a3u_1.x3l_1 = this.a3u_1.x3l_1;
    appendAll(this.c3u_1, builder.c3u_1);
    putAll(this.f3u_1, builder.f3u_1);
    return this;
  };
  protoOf(HttpRequestBuilder).a4g = function (key, capability) {
    var tmp = get_ENGINE_CAPABILITIES_KEY();
    var capabilities = this.f3u_1.u34(tmp, HttpRequestBuilder$setCapability$lambda);
    // Inline function 'kotlin.collections.set' call
    capabilities.b2(key, capability);
  };
  protoOf(HttpRequestBuilder).z4f = function (key) {
    var tmp0_safe_receiver = this.f3u_1.q34(get_ENGINE_CAPABILITIES_KEY());
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y1(key);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function HttpRequestData(url, method, headers, body, executionContext, attributes) {
    this.y3y_1 = url;
    this.z3y_1 = method;
    this.a3z_1 = headers;
    this.b3z_1 = body;
    this.c3z_1 = executionContext;
    this.d3z_1 = attributes;
    var tmp = this;
    var tmp0_safe_receiver = this.d3z_1.q34(get_ENGINE_CAPABILITIES_KEY());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z1();
    tmp.e3z_1 = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  }
  protoOf(HttpRequestData).toString = function () {
    return 'HttpRequestData(url=' + this.y3y_1.toString() + ', method=' + this.z3y_1.toString() + ')';
  };
  function HttpResponseData(statusCode, requestTime, headers, version, body, callContext) {
    this.i3v_1 = statusCode;
    this.j3v_1 = requestTime;
    this.k3v_1 = headers;
    this.l3v_1 = version;
    this.m3v_1 = body;
    this.n3v_1 = callContext;
    this.o3v_1 = GMTDate();
  }
  protoOf(HttpResponseData).toString = function () {
    return 'HttpResponseData=(statusCode=' + this.i3v_1.toString() + ')';
  };
  function url(_this__u8e3s4, urlString) {
    takeFrom_0(_this__u8e3s4.a3u_1, urlString);
  }
  function isUpgradeRequest(_this__u8e3s4) {
    var tmp = _this__u8e3s4.b3z_1;
    return tmp instanceof ClientUpgradeContent;
  }
  function Phases() {
    Phases_instance = this;
    this.w40_1 = new PipelinePhase('Before');
    this.x40_1 = new PipelinePhase('State');
    this.y40_1 = new PipelinePhase('Transform');
    this.z40_1 = new PipelinePhase('Render');
    this.a41_1 = new PipelinePhase('Send');
  }
  var Phases_instance;
  function Phases_getInstance() {
    if (Phases_instance == null)
      new Phases();
    return Phases_instance;
  }
  function HttpRequestPipeline(developmentMode) {
    Phases_getInstance();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance().w40_1, Phases_getInstance().x40_1, Phases_getInstance().y40_1, Phases_getInstance().z40_1, Phases_getInstance().a41_1]);
    this.m4j_1 = developmentMode;
  }
  protoOf(HttpRequestPipeline).n3b = function () {
    return this.m4j_1;
  };
  function Phases_0() {
    Phases_instance_0 = this;
    this.q3u_1 = new PipelinePhase('Before');
    this.r3u_1 = new PipelinePhase('State');
    this.s3u_1 = new PipelinePhase('Monitoring');
    this.t3u_1 = new PipelinePhase('Engine');
    this.u3u_1 = new PipelinePhase('Receive');
  }
  var Phases_instance_0;
  function Phases_getInstance_0() {
    if (Phases_instance_0 == null)
      new Phases_0();
    return Phases_instance_0;
  }
  function HttpSendPipeline(developmentMode) {
    Phases_getInstance_0();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance_0().q3u_1, Phases_getInstance_0().r3u_1, Phases_getInstance_0().s3u_1, Phases_getInstance_0().t3u_1, Phases_getInstance_0().u3u_1]);
    this.u4j_1 = developmentMode;
  }
  protoOf(HttpSendPipeline).n3b = function () {
    return this.u4j_1;
  };
  function get_BodyTypeAttributeKey() {
    _init_properties_RequestBody_kt__bo3lwf();
    return BodyTypeAttributeKey;
  }
  var BodyTypeAttributeKey;
  var properties_initialized_RequestBody_kt_agyv1b;
  function _init_properties_RequestBody_kt__bo3lwf() {
    if (!properties_initialized_RequestBody_kt_agyv1b) {
      properties_initialized_RequestBody_kt_agyv1b = true;
      BodyTypeAttributeKey = new AttributeKey('BodyTypeAttributeKey');
    }
  }
  function accept(_this__u8e3s4, contentType) {
    return _this__u8e3s4.p3i().x38(HttpHeaders_getInstance().m3e_1, contentType.toString());
  }
  function DefaultHttpResponse(call, responseData) {
    HttpResponse.call(this);
    this.v4j_1 = call;
    this.w4j_1 = responseData.n3v_1;
    this.x4j_1 = responseData.i3v_1;
    this.y4j_1 = responseData.l3v_1;
    this.z4j_1 = responseData.j3v_1;
    this.a4k_1 = responseData.o3v_1;
    var tmp = this;
    var tmp_0 = responseData.m3v_1;
    var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel) ? tmp_0 : null;
    tmp.b4k_1 = tmp0_elvis_lhs == null ? Companion_getInstance().u2p() : tmp0_elvis_lhs;
    this.c4k_1 = responseData.k3v_1;
  }
  protoOf(DefaultHttpResponse).h3x = function () {
    return this.v4j_1;
  };
  protoOf(DefaultHttpResponse).pj = function () {
    return this.w4j_1;
  };
  protoOf(DefaultHttpResponse).u3n = function () {
    return this.x4j_1;
  };
  protoOf(DefaultHttpResponse).s3x = function () {
    return this.y4j_1;
  };
  protoOf(DefaultHttpResponse).t3x = function () {
    return this.z4j_1;
  };
  protoOf(DefaultHttpResponse).u3x = function () {
    return this.a4k_1;
  };
  protoOf(DefaultHttpResponse).k3w = function () {
    return this.b4k_1;
  };
  protoOf(DefaultHttpResponse).p3i = function () {
    return this.c4k_1;
  };
  function HttpResponse() {
  }
  protoOf(HttpResponse).toString = function () {
    return 'HttpResponse[' + get_request(this).m3w().toString() + ', ' + this.u3n().toString() + ']';
  };
  function get_request(_this__u8e3s4) {
    return _this__u8e3s4.h3x().j3w();
  }
  function complete(_this__u8e3s4) {
    var tmp = ensureNotNull(_this__u8e3s4.pj().w8(Key_instance));
    var job = isInterface(tmp, CompletableJob) ? tmp : THROW_CCE();
    job.mr();
  }
  function bodyAsText(_this__u8e3s4, fallbackCharset, $completion) {
    fallbackCharset = fallbackCharset === VOID ? Charsets_getInstance().w30_1 : fallbackCharset;
    var tmp = new $bodyAsTextCOROUTINE$22(_this__u8e3s4, fallbackCharset, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function $bodyAsTextCOROUTINE$22(_this__u8e3s4, fallbackCharset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l4k_1 = _this__u8e3s4;
    this.m4k_1 = fallbackCharset;
  }
  protoOf($bodyAsTextCOROUTINE$22).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = charset_0(this.l4k_1);
            tmp_0.n4k_1 = tmp0_elvis_lhs == null ? this.m4k_1 : tmp0_elvis_lhs;
            this.o4k_1 = this.n4k_1.z30();
            var tmp_1 = this;
            tmp_1.p4k_1 = this.l4k_1;
            this.j8_1 = 1;
            var tmp_2 = this.p4k_1.h3x();
            var tmp_3 = JsType_instance;
            var tmp_4 = getKClass(ByteReadPacket);
            var tmp_5;
            try {
              tmp_5 = createKType(getKClass(ByteReadPacket), arrayOf([]), false);
            } catch ($p) {
              var tmp_6;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_6 = null;
              } else {
                throw $p;
              }
              tmp_5 = tmp_6;
            }

            suspendResult = tmp_2.l3w(typeInfoImpl(tmp_3, tmp_4, tmp_5), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var input = suspendResult instanceof ByteReadPacket ? suspendResult : THROW_CCE();
            return decode(this.o4k_1, input);
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function Phases_1() {
    Phases_instance_1 = this;
    this.y3u_1 = new PipelinePhase('Receive');
    this.z3u_1 = new PipelinePhase('Parse');
    this.a3v_1 = new PipelinePhase('Transform');
    this.b3v_1 = new PipelinePhase('State');
    this.c3v_1 = new PipelinePhase('After');
  }
  var Phases_instance_1;
  function Phases_getInstance_1() {
    if (Phases_instance_1 == null)
      new Phases_1();
    return Phases_instance_1;
  }
  function HttpResponsePipeline(developmentMode) {
    Phases_getInstance_1();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance_1().y3u_1, Phases_getInstance_1().z3u_1, Phases_getInstance_1().a3v_1, Phases_getInstance_1().b3v_1, Phases_getInstance_1().c3v_1]);
    this.x4k_1 = developmentMode;
  }
  protoOf(HttpResponsePipeline).n3b = function () {
    return this.x4k_1;
  };
  function Phases_2() {
    Phases_instance_2 = this;
    this.b41_1 = new PipelinePhase('Before');
    this.c41_1 = new PipelinePhase('State');
    this.d41_1 = new PipelinePhase('After');
  }
  var Phases_instance_2;
  function Phases_getInstance_2() {
    if (Phases_instance_2 == null)
      new Phases_2();
    return Phases_instance_2;
  }
  function HttpReceivePipeline(developmentMode) {
    Phases_getInstance_2();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance_2().b41_1, Phases_getInstance_2().c41_1, Phases_getInstance_2().d41_1]);
    this.f4l_1 = developmentMode;
  }
  protoOf(HttpReceivePipeline).n3b = function () {
    return this.f4l_1;
  };
  function HttpResponseContainer(expectedType, response) {
    this.h3w_1 = expectedType;
    this.i3w_1 = response;
  }
  protoOf(HttpResponseContainer).vd = function () {
    return this.h3w_1;
  };
  protoOf(HttpResponseContainer).wd = function () {
    return this.i3w_1;
  };
  protoOf(HttpResponseContainer).toString = function () {
    return 'HttpResponseContainer(expectedType=' + this.h3w_1.toString() + ', response=' + toString(this.i3w_1) + ')';
  };
  protoOf(HttpResponseContainer).hashCode = function () {
    var result = this.h3w_1.hashCode();
    result = imul(result, 31) + hashCode(this.i3w_1) | 0;
    return result;
  };
  protoOf(HttpResponseContainer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpResponseContainer))
      return false;
    var tmp0_other_with_cast = other instanceof HttpResponseContainer ? other : THROW_CCE();
    if (!this.h3w_1.equals(tmp0_other_with_cast.h3w_1))
      return false;
    if (!equals(this.i3w_1, tmp0_other_with_cast.i3w_1))
      return false;
    return true;
  };
  function checkCapabilities($this) {
    var tmp0_safe_receiver = $this.g4l_1.f3u_1.q34(get_ENGINE_CAPABILITIES_KEY());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z1();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = tmp1_safe_receiver.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        if (!(element == null) ? isInterface(element, HttpClientPlugin) : false) {
          destination.e(element);
        }
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = tmp2_safe_receiver.g();
      while (tmp0_iterator_0.h()) {
        var element_0 = tmp0_iterator_0.i();
        // Inline function 'io.ktor.client.statement.HttpStatement.checkCapabilities.<anonymous>' call
        $l$block: {
          // Inline function 'kotlin.requireNotNull' call
          // Inline function 'kotlin.contracts.contract' call
          if (pluginOrNull($this.h4l_1, element_0) == null) {
            // Inline function 'io.ktor.client.statement.HttpStatement.checkCapabilities.<anonymous>.<anonymous>' call
            var message = 'Consider installing ' + toString(element_0) + ' plugin because the request requires it to be installed';
            throw IllegalArgumentException_init_$Create$(toString(message));
          } else {
            break $l$block;
          }
        }
      }
    }
  }
  function HttpStatement$execute$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpStatement$execute$slambda).r4l = function (it, $completion) {
    var tmp = this.x43(it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpStatement$execute$slambda).m9 = function (p1, $completion) {
    return this.r4l(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpStatement$execute$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = save(this.q4l_1.h3x(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var savedCall = suspendResult;
            return savedCall.b3t();
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpStatement$execute$slambda).x43 = function (it, completion) {
    var i = new HttpStatement$execute$slambda(completion);
    i.q4l_1 = it;
    return i;
  };
  function HttpStatement$execute$slambda_0(resultContinuation) {
    var i = new HttpStatement$execute$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.r4l(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $executeCOROUTINE$23(_this__u8e3s4, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a4m_1 = _this__u8e3s4;
    this.b4m_1 = block;
  }
  protoOf($executeCOROUTINE$23).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 13;
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.k8_1 = 12;
            this.j8_1 = 2;
            suspendResult = this.a4m_1.h4m(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.d4m_1 = suspendResult;
            this.j8_1 = 3;
            continue $sm;
          case 3:
            this.j8_1 = 4;
            continue $sm;
          case 4:
            this.k8_1 = 10;
            this.j8_1 = 5;
            suspendResult = this.b4m_1(this.d4m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.e4m_1 = suspendResult;
            this.j8_1 = 6;
            var tmp_0 = this;
            continue $sm;
          case 6:
            this.f4m_1 = this.e4m_1;
            this.k8_1 = 12;
            this.j8_1 = 7;
            suspendResult = this.a4m_1.i4m(this.d4m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            return this.f4m_1;
          case 8:
            this.k8_1 = 12;
            this.j8_1 = 9;
            suspendResult = this.a4m_1.i4m(this.d4m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            var tmp_1 = this;
            tmp_1.c4m_1 = Unit_instance;
            this.k8_1 = 13;
            this.j8_1 = 15;
            continue $sm;
          case 10:
            this.k8_1 = 12;
            this.g4m_1 = this.m8_1;
            this.j8_1 = 11;
            suspendResult = this.a4m_1.i4m(this.d4m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            throw this.g4m_1;
          case 12:
            this.k8_1 = 13;
            var tmp_2 = this.m8_1;
            if (tmp_2 instanceof CancellationException) {
              var cause = this.m8_1;
              throw unwrapCancellationException(cause);
            } else {
              throw this.m8_1;
            }

          case 13:
            throw this.m8_1;
          case 14:
            this.k8_1 = 13;
            if (false) {
              this.j8_1 = 1;
              continue $sm;
            }

            this.j8_1 = 15;
            continue $sm;
          case 15:
            return this.c4m_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 13) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function $executeUnsafeCOROUTINE$24(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r4m_1 = _this__u8e3s4;
  }
  protoOf($executeUnsafeCOROUTINE$24).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.k8_1 = 3;
            this.t4m_1 = (new HttpRequestBuilder()).x3z(this.r4m_1.g4l_1);
            this.j8_1 = 2;
            suspendResult = this.r4m_1.h4l_1.d3v(this.t4m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var call = suspendResult;
            var tmp_0 = this;
            return call.b3t();
          case 3:
            this.k8_1 = 4;
            var tmp_1 = this.m8_1;
            if (tmp_1 instanceof CancellationException) {
              var cause = this.m8_1;
              throw unwrapCancellationException(cause);
            } else {
              throw this.m8_1;
            }

          case 4:
            throw this.m8_1;
          case 5:
            this.k8_1 = 4;
            if (false) {
              this.j8_1 = 1;
              continue $sm;
            }

            this.j8_1 = 6;
            continue $sm;
          case 6:
            return this.s4m_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 4) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function $cleanupCOROUTINE$25(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c4n_1 = _this__u8e3s4;
    this.d4n_1 = _this__u8e3s4_0;
  }
  protoOf($cleanupCOROUTINE$25).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            var tmp_0 = this;
            var tmp_1 = ensureNotNull(this.d4n_1.pj().w8(Key_instance));
            tmp_0.e4n_1 = isInterface(tmp_1, CompletableJob) ? tmp_1 : THROW_CCE();
            var tmp_2 = this;
            tmp_2.f4n_1 = this.e4n_1;
            var tmp_3 = this;
            tmp_3.g4n_1 = this.f4n_1;
            this.g4n_1.mr();
            this.k8_1 = 1;
            cancel_1(this.d4n_1.k3w());
            this.k8_1 = 4;
            this.j8_1 = 2;
            continue $sm;
          case 1:
            this.k8_1 = 4;
            var tmp_4 = this.m8_1;
            if (tmp_4 instanceof Error) {
              this.h4n_1 = this.m8_1;
              this.j8_1 = 2;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 2:
            this.k8_1 = 4;
            this.j8_1 = 3;
            suspendResult = this.g4n_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 4) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function HttpStatement(builder, client) {
    this.g4l_1 = builder;
    this.h4l_1 = client;
    checkCapabilities(this);
  }
  protoOf(HttpStatement).i4n = function (block, $completion) {
    var tmp = new $executeCOROUTINE$23(this, block, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpStatement).j4n = function ($completion) {
    return this.i4n(HttpStatement$execute$slambda_0(null), $completion);
  };
  protoOf(HttpStatement).h4m = function ($completion) {
    var tmp = new $executeUnsafeCOROUTINE$24(this, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpStatement).i4m = function (_this__u8e3s4, $completion) {
    var tmp = new $cleanupCOROUTINE$25(this, _this__u8e3s4, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(HttpStatement).toString = function () {
    return 'HttpStatement[' + this.g4l_1.a3u_1.toString() + ']';
  };
  function observable(_this__u8e3s4, context, contentLength, listener) {
    var tmp = GlobalScope_instance;
    return writer(tmp, context, true, observable$slambda_0(contentLength, _this__u8e3s4, listener, null)).fw();
  }
  function observable$slambda($contentLength, $this_observable, $listener, resultContinuation) {
    this.s4n_1 = $contentLength;
    this.t4n_1 = $this_observable;
    this.u4n_1 = $listener;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(observable$slambda).f3y = function ($this$writer, $completion) {
    var tmp = this.g3y($this$writer, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(observable$slambda).m9 = function (p1, $completion) {
    return this.f3y((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(observable$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 15;
            this.j8_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.x4n_1 = get_ByteArrayPool();
            this.y4n_1 = this.x4n_1.h2z();
            this.j8_1 = 2;
            continue $sm;
          case 2:
            this.j8_1 = 3;
            continue $sm;
          case 3:
            this.k8_1 = 14;
            var tmp_1 = this;
            tmp_1.a4o_1 = this.y4n_1;
            var tmp_2 = this;
            var tmp0_elvis_lhs = this.s4n_1;
            tmp_2.b4o_1 = tmp0_elvis_lhs == null ? new Long(-1, -1) : tmp0_elvis_lhs;
            this.c4o_1 = new Long(0, 0);
            this.j8_1 = 4;
            continue $sm;
          case 4:
            if (!!this.t4n_1.o2q()) {
              this.j8_1 = 8;
              continue $sm;
            }

            this.j8_1 = 5;
            suspendResult = readAvailable(this.t4n_1, this.a4o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.d4o_1 = suspendResult;
            this.j8_1 = 6;
            suspendResult = this.v4n_1.fw().g2w(this.a4o_1, 0, this.d4o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp_3 = this;
            var this_0 = this.c4o_1;
            var other = this.d4o_1;
            tmp_3.c4o_1 = this_0.l2(toLong(other));
            this.j8_1 = 7;
            suspendResult = this.u4n_1(this.c4o_1, this.b4o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.j8_1 = 4;
            continue $sm;
          case 8:
            this.e4o_1 = this.t4n_1.y2o();
            this.v4n_1.fw().v11(this.e4o_1);
            if (this.e4o_1 == null && this.c4o_1.equals(new Long(0, 0))) {
              this.j8_1 = 9;
              suspendResult = this.u4n_1(this.c4o_1, this.b4o_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.j8_1 = 10;
              continue $sm;
            }

          case 9:
            this.j8_1 = 10;
            continue $sm;
          case 10:
            this.z4n_1 = Unit_instance;
            this.k8_1 = 15;
            this.j8_1 = 11;
            var tmp_4 = this;
            continue $sm;
          case 11:
            this.k8_1 = 15;
            var tmp_5 = this;
            this.x4n_1.i2z(this.y4n_1);
            tmp_5.w4n_1 = Unit_instance;
            this.j8_1 = 13;
            continue $sm;
          case 12:
            this.k8_1 = 15;
            this.x4n_1.i2z(this.y4n_1);
            if (false) {
              this.j8_1 = 1;
              continue $sm;
            }

            this.j8_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
          case 14:
            this.k8_1 = 15;
            var t = this.m8_1;
            this.x4n_1.i2z(this.y4n_1);
            throw t;
          case 15:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 15) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(observable$slambda).g3y = function ($this$writer, completion) {
    var i = new observable$slambda(this.s4n_1, this.t4n_1, this.u4n_1, completion);
    i.v4n_1 = $this$writer;
    return i;
  };
  function observable$slambda_0($contentLength, $this_observable, $listener, resultContinuation) {
    var i = new observable$slambda($contentLength, $this_observable, $listener, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.f3y($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function get_HttpRequestCreated() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpRequestCreated;
  }
  var HttpRequestCreated;
  function get_HttpRequestIsReadyForSending() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpRequestIsReadyForSending;
  }
  var HttpRequestIsReadyForSending;
  function get_HttpResponseReceived() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseReceived;
  }
  var HttpResponseReceived;
  function get_HttpResponseReceiveFailed() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseReceiveFailed;
  }
  var HttpResponseReceiveFailed;
  function get_HttpResponseCancelled() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseCancelled;
  }
  var HttpResponseCancelled;
  function HttpResponseReceiveFail(response, cause) {
    this.f4o_1 = response;
    this.g4o_1 = cause;
  }
  var properties_initialized_ClientEvents_kt_rdee4m;
  function _init_properties_ClientEvents_kt__xuvbz8() {
    if (!properties_initialized_ClientEvents_kt_rdee4m) {
      properties_initialized_ClientEvents_kt_rdee4m = true;
      HttpRequestCreated = new EventDefinition();
      HttpRequestIsReadyForSending = new EventDefinition();
      HttpResponseReceived = new EventDefinition();
      HttpResponseReceiveFailed = new EventDefinition();
      HttpResponseCancelled = new EventDefinition();
    }
  }
  function EmptyContent() {
    EmptyContent_instance = this;
    NoContent.call(this);
    this.i4o_1 = new Long(0, 0);
  }
  protoOf(EmptyContent).v3n = function () {
    return this.i4o_1;
  };
  protoOf(EmptyContent).toString = function () {
    return 'EmptyContent';
  };
  var EmptyContent_instance;
  function EmptyContent_getInstance() {
    if (EmptyContent_instance == null)
      new EmptyContent();
    return EmptyContent_instance;
  }
  function buildHeaders(block) {
    var tmp;
    if (block === VOID) {
      tmp = buildHeaders$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    // Inline function 'kotlin.apply' call
    var this_0 = new HeadersBuilder();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    return this_0.b21();
  }
  function buildHeaders$lambda($this$null) {
    return Unit_instance;
  }
  function ioDispatcher() {
    return Dispatchers_getInstance().nv_1;
  }
  function Js() {
  }
  protoOf(Js).j4o = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpClientEngineConfig();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    return new JsClientEngine(this_0);
  };
  protoOf(Js).e3v = function (block) {
    return this.j4o(block);
  };
  var Js_instance;
  function Js_getInstance() {
    return Js_instance;
  }
  function createWebSocket($this, urlString_capturingHack, headers) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = headers.m38();
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.client.engine.js.JsClientEngine.createWebSocket.<anonymous>' call
      if (equals_0(element, 'sec-websocket-protocol', true)) {
        destination.e(element);
      }
    }
    var protocolHeaderNames = destination;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = protocolHeaderNames.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'io.ktor.client.engine.js.JsClientEngine.createWebSocket.<anonymous>' call
      var tmp0_safe_receiver = headers.l38(element_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.e(tmp0_safe_receiver);
      }
    }
    var this_1 = flatten(destination_0);
    var protocols = copyToArray(this_1);
    var tmp;
    if (get_platform(PlatformUtils_getInstance()).f2_1 === 2) {
      tmp = new WebSocket(urlString_capturingHack, protocols);
    } else {
      var ws_capturingHack = eval('require')('ws');
      var headers_capturingHack = new JsClientEngine$createWebSocket$headers_capturingHack$1();
      headers.o38(JsClientEngine$createWebSocket$lambda(headers_capturingHack));
      tmp = new ws_capturingHack(urlString_capturingHack, protocols, {headers: headers_capturingHack});
    }
    return tmp;
  }
  function executeWebSocketRequest($this, request, callContext, $completion) {
    var tmp = new $executeWebSocketRequestCOROUTINE$27($this, request, callContext, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function JsClientEngine$createWebSocket$headers_capturingHack$1() {
  }
  function JsClientEngine$createWebSocket$lambda($headers_capturingHack) {
    return function (name, values) {
      $headers_capturingHack[name] = joinToString(values, ',');
      return Unit_instance;
    };
  }
  function $executeCOROUTINE$26(_this__u8e3s4, data, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h4p_1 = _this__u8e3s4;
    this.i4p_1 = data;
  }
  protoOf($executeCOROUTINE$26).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 6;
            this.j8_1 = 1;
            suspendResult = callContext(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.j4p_1 = suspendResult;
            this.k4p_1 = this.i4p_1.d3z_1.p34(get_CLIENT_CONFIG());
            if (isUpgradeRequest(this.i4p_1)) {
              this.j8_1 = 5;
              suspendResult = executeWebSocketRequest(this.h4p_1, this.i4p_1, this.j4p_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.j8_1 = 2;
              continue $sm;
            }

          case 2:
            this.l4p_1 = GMTDate();
            this.j8_1 = 3;
            suspendResult = toRaw(this.i4p_1, this.k4p_1, this.j4p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.m4p_1 = suspendResult;
            this.j8_1 = 4;
            suspendResult = commonFetch(this.i4p_1.y3y_1.toString(), this.m4p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var rawResponse = suspendResult;
            var status = new HttpStatusCode(rawResponse.status, rawResponse.statusText);
            var headers = mapToKtor(rawResponse.headers);
            var version = Companion_getInstance_3().a3j_1;
            var body = readBody(CoroutineScope_0(this.j4p_1), rawResponse);
            return new HttpResponseData(status, this.l4p_1, headers, version, body, this.j4p_1);
          case 5:
            return suspendResult;
          case 6:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 6) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function $executeWebSocketRequestCOROUTINE$27(_this__u8e3s4, request, callContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s4o_1 = _this__u8e3s4;
    this.t4o_1 = request;
    this.u4o_1 = callContext;
  }
  protoOf($executeWebSocketRequestCOROUTINE$27).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            this.v4o_1 = GMTDate();
            this.w4o_1 = this.t4o_1.y3y_1.toString();
            this.x4o_1 = createWebSocket(this.s4o_1, this.w4o_1, this.t4o_1.a3z_1);
            this.y4o_1 = new JsWebSocketSession(this.u4o_1, this.x4o_1);
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = awaitConnection(this.x4o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.k8_1 = 4;
            this.j8_1 = 3;
            continue $sm;
          case 2:
            this.k8_1 = 4;
            var tmp_0 = this.m8_1;
            if (tmp_0 instanceof Error) {
              var cause = this.m8_1;
              cancel_3(this.u4o_1, CancellationException_init_$Create$_0('Failed to connect to ' + this.w4o_1, cause));
              throw cause;
            } else {
              throw this.m8_1;
            }

          case 3:
            this.k8_1 = 4;
            return new HttpResponseData(Companion_getInstance_2().i3j_1, this.v4o_1, Companion_getInstance_4().j3e_1, Companion_getInstance_3().a3j_1, this.y4o_1, this.u4o_1);
          case 4:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 4) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function JsClientEngine(config) {
    HttpClientEngineBase.call(this, 'ktor-js');
    this.r4p_1 = config;
    this.s4p_1 = setOf_0([Plugin_getInstance_5(), WebSocketCapability_instance]);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.r4p_1.u40_1 == null)) {
      // Inline function 'io.ktor.client.engine.js.JsClientEngine.<anonymous>' call
      var message = 'Proxy unsupported in Js engine.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  protoOf(JsClientEngine).o3u = function () {
    return this.r4p_1;
  };
  protoOf(JsClientEngine).f3z = function () {
    return this.s4p_1;
  };
  protoOf(JsClientEngine).l40 = function (data, $completion) {
    var tmp = new $executeCOROUTINE$26(this, data, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  function mapToKtor(_this__u8e3s4) {
    return buildHeaders(mapToKtor$lambda(_this__u8e3s4));
  }
  function awaitConnection(_this__u8e3s4, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.ln();
    $l$block: {
      // Inline function 'io.ktor.client.engine.js.awaitConnection.<anonymous>' call
      if (cancellable.vo()) {
        break $l$block;
      }
      var eventListener = awaitConnection$lambda(cancellable, _this__u8e3s4);
      _this__u8e3s4.addEventListener('open', eventListener);
      _this__u8e3s4.addEventListener('error', eventListener);
      cancellable.xo(awaitConnection$lambda_0(_this__u8e3s4, eventListener));
    }
    return cancellable.mn();
  }
  function asString(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.client.engine.js.asString.<anonymous>' call
    var tmp = JSON;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = ['message', 'target', 'type', 'isTrusted'];
    this_0.o7(tmp.stringify(_this__u8e3s4, tmp$ret$2));
    return this_0.toString();
  }
  function JsError(origin) {
    extendThrowable(this, 'Error from javascript[' + origin + '].');
    captureStack(this, JsError);
    this.t4p_1 = origin;
  }
  function mapToKtor$lambda$lambda($this_buildHeaders) {
    return function (value, key) {
      $this_buildHeaders.x38(key, value);
      return Unit_instance;
    };
  }
  function mapToKtor$lambda($this_mapToKtor) {
    return function ($this$buildHeaders) {
      // Inline function 'kotlin.js.asDynamic' call
      $this_mapToKtor.forEach(mapToKtor$lambda$lambda($this$buildHeaders));
      return Unit_instance;
    };
  }
  function awaitConnection$lambda($continuation, $this_awaitConnection) {
    return function (event) {
      var tmp0_subject = event.type;
      var tmp;
      if (tmp0_subject === 'open') {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = $continuation;
        // Inline function 'kotlin.Companion.success' call
        var value = $this_awaitConnection;
        var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
        this_0.u8(tmp$ret$0);
        tmp = Unit_instance;
      } else if (tmp0_subject === 'error') {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        var this_1 = $continuation;
        // Inline function 'kotlin.Companion.failure' call
        var exception = WebSocketException_init_$Create$(asString(event));
        var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
        this_1.u8(tmp$ret$2);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function awaitConnection$lambda_0($this_awaitConnection, $eventListener) {
    return function (it) {
      $this_awaitConnection.removeEventListener('open', $eventListener);
      $this_awaitConnection.removeEventListener('error', $eventListener);
      var tmp;
      if (!(it == null)) {
        $this_awaitConnection.close();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function toRaw(_this__u8e3s4, clientConfig, callContext, $completion) {
    var tmp = new $toRawCOROUTINE$28(_this__u8e3s4, clientConfig, callContext, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function buildObject(block) {
    // Inline function 'kotlin.apply' call
    var tmp = {};
    var this_0 = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    return this_0;
  }
  function toRaw$lambda($jsHeaders) {
    return function (key, value) {
      $jsHeaders[key] = value;
      return Unit_instance;
    };
  }
  function toRaw$slambda($content, resultContinuation) {
    this.q4q_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(toRaw$slambda).f3y = function ($this$writer, $completion) {
    var tmp = this.g3y($this$writer, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(toRaw$slambda).m9 = function (p1, $completion) {
    return this.f3y((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(toRaw$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.q4q_1.b3o(this.r4q_1.fw(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(toRaw$slambda).g3y = function ($this$writer, completion) {
    var i = new toRaw$slambda(this.q4q_1, completion);
    i.r4q_1 = $this$writer;
    return i;
  };
  function toRaw$slambda_0($content, resultContinuation) {
    var i = new toRaw$slambda($content, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.f3y($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function toRaw$lambda_0($this_toRaw, $jsHeaders, $clientConfig, $bodyBytes) {
    return function ($this$buildObject) {
      $this$buildObject.method = $this_toRaw.z3y_1.y3i_1;
      $this$buildObject.headers = $jsHeaders;
      var tmp;
      if ($clientConfig.k3u_1) {
        // Inline function 'org.w3c.fetch.FOLLOW' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = 'follow';
      } else {
        // Inline function 'org.w3c.fetch.MANUAL' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = 'manual';
      }
      $this$buildObject.redirect = tmp;
      var tmp0_safe_receiver = $bodyBytes;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        $this$buildObject.body = new Uint8Array(toTypedArray(tmp0_safe_receiver));
      }
      return Unit_instance;
    };
  }
  function $toRawCOROUTINE$28(_this__u8e3s4, clientConfig, callContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c4q_1 = _this__u8e3s4;
    this.d4q_1 = clientConfig;
    this.e4q_1 = callContext;
  }
  protoOf($toRawCOROUTINE$28).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            this.f4q_1 = {};
            mergeHeaders(this.c4q_1.a3z_1, this.c4q_1.b3z_1, toRaw$lambda(this.f4q_1));
            this.g4q_1 = this.c4q_1.b3z_1;
            var tmp_0 = this.g4q_1;
            if (tmp_0 instanceof ByteArrayContent) {
              this.h4q_1 = this.g4q_1.w3n();
              this.j8_1 = 3;
              continue $sm;
            } else {
              var tmp_1 = this.g4q_1;
              if (tmp_1 instanceof ReadChannelContent) {
                this.j8_1 = 2;
                suspendResult = this.g4q_1.z3n().i2w(VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_2 = this.g4q_1;
                if (tmp_2 instanceof WriteChannelContent) {
                  this.j8_1 = 1;
                  var tmp_3 = GlobalScope_instance;
                  suspendResult = writer(tmp_3, this.e4q_1, VOID, toRaw$slambda_0(this.g4q_1, null)).fw().i2w(VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.h4q_1 = null;
                  this.j8_1 = 3;
                  continue $sm;
                }
              }
            }

          case 1:
            var ARGUMENT = suspendResult;
            this.h4q_1 = readBytes(ARGUMENT);
            this.j8_1 = 3;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.h4q_1 = readBytes(ARGUMENT_0);
            this.j8_1 = 3;
            continue $sm;
          case 3:
            var bodyBytes = this.h4q_1;
            return buildObject(toRaw$lambda_0(this.c4q_1, this.f4q_1, this.d4q_1, bodyBytes));
          case 4:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 4) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function asByteArray(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    return new Int8Array(_this__u8e3s4.buffer, _this__u8e3s4.byteOffset, _this__u8e3s4.length);
  }
  function readBodyBrowser(_this__u8e3s4, response) {
    var tmp0_elvis_lhs = response.body;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance().u2p();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stream = tmp;
    return channelFromStream(_this__u8e3s4, stream);
  }
  function channelFromStream(_this__u8e3s4, stream) {
    return writer(_this__u8e3s4, VOID, VOID, channelFromStream$slambda_0(stream, null)).fw();
  }
  function readChunk(_this__u8e3s4, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.ln();
    // Inline function 'io.ktor.client.engine.js.browser.readChunk.<anonymous>' call
    var tmp = _this__u8e3s4.read();
    var tmp_0 = tmp.then(readChunk$lambda(cancellable));
    tmp_0.catch(readChunk$lambda_0(cancellable));
    return cancellable.mn();
  }
  function channelFromStream$slambda($stream, resultContinuation) {
    this.a4r_1 = $stream;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(channelFromStream$slambda).f3y = function ($this$writer, $completion) {
    var tmp = this.g3y($this$writer, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(channelFromStream$slambda).m9 = function (p1, $completion) {
    return this.f3y((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(channelFromStream$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 6;
            this.c4r_1 = this.a4r_1.getReader();
            this.j8_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.j8_1 = 8;
              continue $sm;
            }

            this.k8_1 = 5;
            this.j8_1 = 2;
            suspendResult = readChunk(this.c4r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.d4r_1 = suspendResult;
            if (this.d4r_1 == null) {
              this.k8_1 = 6;
              this.j8_1 = 8;
              var tmp_0 = this;
              continue $sm;
            } else {
              this.e4r_1 = this.d4r_1;
              this.j8_1 = 3;
              continue $sm;
            }

          case 3:
            this.f4r_1 = this.e4r_1;
            this.j8_1 = 4;
            suspendResult = writeFully(this.b4r_1.fw(), asByteArray(this.f4r_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.b4r_1.fw().g8();
            this.k8_1 = 6;
            this.j8_1 = 7;
            continue $sm;
          case 5:
            this.k8_1 = 6;
            var tmp_1 = this.m8_1;
            if (tmp_1 instanceof Error) {
              var cause = this.m8_1;
              this.c4r_1.cancel(cause);
              throw cause;
            } else {
              throw this.m8_1;
            }

          case 6:
            throw this.m8_1;
          case 7:
            this.k8_1 = 6;
            this.j8_1 = 1;
            continue $sm;
          case 8:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 6) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(channelFromStream$slambda).g3y = function ($this$writer, completion) {
    var i = new channelFromStream$slambda(this.a4r_1, completion);
    i.b4r_1 = $this$writer;
    return i;
  };
  function channelFromStream$slambda_0($stream, resultContinuation) {
    var i = new channelFromStream$slambda($stream, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.f3y($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function readChunk$lambda($continuation) {
    return function (it) {
      var chunk = it.value;
      var result = it.done || chunk == null ? null : chunk;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(result);
      $continuation.u8(tmp$ret$0);
      return Unit_instance;
    };
  }
  function readChunk$lambda_0($continuation) {
    return function (cause) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(cause));
      this_0.u8(tmp$ret$0);
      return Unit_instance;
    };
  }
  function commonFetch(input, init, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.ln();
    // Inline function 'io.ktor.client.engine.js.compatibility.commonFetch.<anonymous>' call
    var controller = AbortController_0();
    init.signal = controller.signal;
    cancellable.xo(commonFetch$lambda(controller));
    var promise = get_platform(PlatformUtils_getInstance()).f2_1 === 2 ? fetch(input, init) : jsRequireNodeFetch()(input, init);
    var tmp = commonFetch$lambda_0(cancellable);
    promise.then(tmp, commonFetch$lambda_1(cancellable));
    return cancellable.mn();
  }
  function readBody(_this__u8e3s4, response) {
    return get_platform(PlatformUtils_getInstance()).f2_1 === 3 ? readBodyNode(_this__u8e3s4, response) : readBodyBrowser(_this__u8e3s4, response);
  }
  function AbortController_0() {
    var tmp;
    if (get_platform(PlatformUtils_getInstance()).f2_1 === 2) {
      tmp = new AbortController();
    } else {
      var controller = eval('require')('abort-controller');
      tmp = new controller();
    }
    return tmp;
  }
  function jsRequireNodeFetch() {
    var tmp;
    try {
      tmp = eval('require')('node-fetch');
    } catch ($p) {
      var tmp_0;
      var cause = $p;
      throw Error_init_$Create$("Error loading module 'node-fetch': " + cause);
    }
    return tmp;
  }
  function commonFetch$lambda($controller) {
    return function (it) {
      $controller.abort();
      return Unit_instance;
    };
  }
  function commonFetch$lambda_0($continuation) {
    return function (it) {
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
      $continuation.u8(tmp$ret$0);
      return Unit_instance;
    };
  }
  function commonFetch$lambda_1($continuation) {
    return function (it) {
      // Inline function 'kotlin.Companion.failure' call
      var exception = Error_init_$Create$_0('Fail to fetch', it);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      $continuation.u8(tmp$ret$0);
      return Unit_instance;
    };
  }
  function readBodyNode(_this__u8e3s4, response) {
    return writer(_this__u8e3s4, VOID, VOID, readBodyNode$slambda_0(response, null)).fw();
  }
  function readBodyNode$slambda$lambda($responseData, $body) {
    return function (chunk) {
      _ChannelResult___get_isSuccess__impl__odq1z9($responseData.p11(asByteArray(new Uint8Array(chunk))));
      return $body.pause();
    };
  }
  function readBodyNode$slambda$lambda_0($responseData, $this_writer) {
    return function (error) {
      var cause = new JsError(error);
      $responseData.v11(cause);
      return $this_writer.fw().v11(cause);
    };
  }
  function readBodyNode$slambda$lambda_1($responseData) {
    return function () {
      return $responseData.x11();
    };
  }
  function readBodyNode$slambda($response, resultContinuation) {
    this.o4r_1 = $response;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(readBodyNode$slambda).f3y = function ($this$writer, $completion) {
    var tmp = this.g3y($this$writer, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(readBodyNode$slambda).m9 = function (p1, $completion) {
    return this.f3y((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(readBodyNode$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 6;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.o4r_1.body;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              var message = 'Fail to get body';
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.q4r_1 = tmp_1;
            this.r4r_1 = Channel(1);
            this.q4r_1.on('data', readBodyNode$slambda$lambda(this.r4r_1, this.q4r_1));
            this.q4r_1.on('error', readBodyNode$slambda$lambda_0(this.r4r_1, this.p4r_1));
            this.q4r_1.on('end', readBodyNode$slambda$lambda_1(this.r4r_1));
            this.k8_1 = 5;
            this.s4r_1 = this.r4r_1.g();
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.j8_1 = 2;
            suspendResult = this.s4r_1.jz(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!suspendResult) {
              this.j8_1 = 4;
              continue $sm;
            }

            this.t4r_1 = this.s4r_1.i();
            this.j8_1 = 3;
            suspendResult = writeFully(this.p4r_1.fw(), this.t4r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.p4r_1.fw().g8();
            this.q4r_1.resume();
            this.j8_1 = 1;
            continue $sm;
          case 4:
            this.k8_1 = 6;
            this.j8_1 = 7;
            continue $sm;
          case 5:
            this.k8_1 = 6;
            var tmp_2 = this.m8_1;
            if (tmp_2 instanceof Error) {
              var cause = this.m8_1;
              this.q4r_1.destroy(cause);
              throw cause;
            } else {
              throw this.m8_1;
            }

          case 6:
            throw this.m8_1;
          case 7:
            this.k8_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 6) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(readBodyNode$slambda).g3y = function ($this$writer, completion) {
    var i = new readBodyNode$slambda(this.o4r_1, completion);
    i.p4r_1 = $this$writer;
    return i;
  };
  function readBodyNode$slambda_0($response, resultContinuation) {
    var i = new readBodyNode$slambda($response, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.f3y($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function platformRequestDefaultTransform(contentType, context, body) {
    return null;
  }
  function platformResponseDefaultTransformers(_this__u8e3s4) {
  }
  function getResponseObserverContext($completion) {
    return EmptyCoroutineContext_getInstance();
  }
  function isReservedStatusCode(_this__u8e3s4, $this) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.client.plugins.websocket.JsWebSocketSession.isReservedStatusCode.<anonymous>' call
    var resolved = Companion_getInstance_5().r3o(_this__u8e3s4);
    return resolved == null || equals(resolved, Codes_CLOSED_ABNORMALLY_getInstance());
  }
  function JsWebSocketSession$lambda(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var event = it;
      var data = event.data;
      var tmp;
      if (data instanceof ArrayBuffer) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = new Int8Array(data);
        tmp = Binary_init_$Create$(false, tmp$ret$3);
      } else {
        if (!(data == null) ? typeof data === 'string' : false) {
          tmp = Text_init_$Create$(data);
        } else {
          var error = IllegalStateException_init_$Create$('Unknown frame type: ' + event.type);
          this$0.w4r_1.lr(error);
          throw error;
        }
      }
      var frame = tmp;
      this$0.x4r_1.p11(frame);
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_0(this$0) {
    return function (it) {
      var cause = WebSocketException_init_$Create$(toString(it));
      this$0.w4r_1.lr(cause);
      this$0.x4r_1.v11(cause);
      this$0.y4r_1.z11();
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_1(this$0) {
    return function (event) {
      var tmp = event.code;
      var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
      var tmp_1 = event.reason;
      var reason = new CloseReason(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE());
      this$0.w4r_1.jr(reason);
      this$0.x4r_1.p11(Close_init_$Create$(reason));
      this$0.x4r_1.x11();
      this$0.y4r_1.z11();
      return Unit_instance;
    };
  }
  function JsWebSocketSession$slambda(this$0, resultContinuation) {
    this.k4s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsWebSocketSession$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(JsWebSocketSession$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsWebSocketSession$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 10;
            var tmp_0 = this;
            tmp_0.m4s_1 = this.k4s_1.y4r_1;
            this.j8_1 = 1;
            continue $sm;
          case 1:
            var tmp_1 = this;
            tmp_1.o4s_1 = this.m4s_1;
            this.p4s_1 = null;
            this.j8_1 = 2;
            continue $sm;
          case 2:
            this.j8_1 = 3;
            continue $sm;
          case 3:
            this.k8_1 = 9;
            this.k8_1 = 8;
            var tmp_2 = this;
            tmp_2.r4s_1 = this.o4s_1;
            this.s4s_1 = this.r4s_1.g();
            this.j8_1 = 4;
            continue $sm;
          case 4:
            this.j8_1 = 5;
            suspendResult = this.s4s_1.jz(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.j8_1 = 6;
              continue $sm;
            }

            var e = this.s4s_1.i();
            switch (e.d3p_1.f2_1) {
              case 0:
                var text = e.e3p_1;
                this.k4s_1.v4r_1.send(String_0(text));
                break;
              case 1:
                var tmp_3 = e.e3p_1;
                var source = tmp_3 instanceof Int8Array ? tmp_3 : THROW_CCE();
                var frameData = source.buffer.slice(source.byteOffset, source.byteOffset + source.byteLength | 0);
                this.k4s_1.v4r_1.send(frameData);
                break;
              case 2:
                var tmp$ret$0;
                l$ret$1: do {
                  var builder = new BytePacketBuilder();
                  try {
                    writeFully_0(builder, e.e3p_1);
                    tmp$ret$0 = builder.b21();
                    break l$ret$1;
                  } catch ($p) {
                    if ($p instanceof Error) {
                      var t = $p;
                      builder.a2p();
                      throw t;
                    } else {
                      throw $p;
                    }
                  }
                }
                 while (false);
                var data = tmp$ret$0;
                var code = readShort(data);
                var reason = data.o30();
                this.k4s_1.w4r_1.jr(new CloseReason(code, reason));
                if (isReservedStatusCode(code, this.k4s_1)) {
                  this.k4s_1.v4r_1.close();
                } else {
                  this.k4s_1.v4r_1.close(code, reason);
                }

                break;
              case 3:
              case 4:
                break;
            }

            this.j8_1 = 4;
            continue $sm;
          case 6:
            this.q4s_1 = Unit_instance;
            this.k8_1 = 10;
            this.j8_1 = 7;
            var tmp_4 = this;
            continue $sm;
          case 7:
            this.k8_1 = 10;
            var tmp_5 = this;
            cancelConsumed(this.o4s_1, this.p4s_1);
            tmp_5.n4s_1 = Unit_instance;
            this.j8_1 = 12;
            continue $sm;
          case 8:
            this.k8_1 = 9;
            var tmp_6 = this.m8_1;
            if (tmp_6 instanceof Error) {
              var e_0 = this.m8_1;
              var tmp_7 = this;
              this.p4s_1 = e_0;
              throw e_0;
            } else {
              throw this.m8_1;
            }

          case 9:
            this.k8_1 = 10;
            var t_0 = this.m8_1;
            cancelConsumed(this.o4s_1, this.p4s_1);
            throw t_0;
          case 10:
            throw this.m8_1;
          case 11:
            this.k8_1 = 10;
            cancelConsumed(this.o4s_1, this.p4s_1);
            if (false) {
              this.j8_1 = 1;
              continue $sm;
            }

            this.j8_1 = 12;
            continue $sm;
          case 12:
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.k8_1 === 10) {
          throw e_1;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(JsWebSocketSession$slambda).m17 = function ($this$launch, completion) {
    var i = new JsWebSocketSession$slambda(this.k4s_1, completion);
    i.l4s_1 = $this$launch;
    return i;
  };
  function JsWebSocketSession$slambda_0(this$0, resultContinuation) {
    var i = new JsWebSocketSession$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsWebSocketSession$lambda_2(this$0) {
    return function (cause) {
      var tmp;
      if (cause == null) {
        this$0.v4r_1.close();
        tmp = Unit_instance;
      } else {
        this$0.v4r_1.close(Codes_NORMAL_getInstance().o3o_1, 'Client failed');
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function JsWebSocketSession(coroutineContext, websocket) {
    this.u4r_1 = coroutineContext;
    this.v4r_1 = websocket;
    this.w4r_1 = CompletableDeferred();
    this.x4r_1 = Channel(2147483647);
    this.y4r_1 = Channel(2147483647);
    this.z4r_1 = this.x4r_1;
    this.a4s_1 = this.y4r_1;
    this.b4s_1 = this.w4r_1;
    // Inline function 'org.w3c.dom.ARRAYBUFFER' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = 'arraybuffer';
    this.v4r_1.binaryType = tmp$ret$2;
    this.v4r_1.addEventListener('message', JsWebSocketSession$lambda(this));
    this.v4r_1.addEventListener('error', JsWebSocketSession$lambda_0(this));
    this.v4r_1.addEventListener('close', JsWebSocketSession$lambda_1(this));
    launch(this, VOID, VOID, JsWebSocketSession$slambda_0(this, null));
    var tmp0_safe_receiver = this.u4r_1.w8(Key_instance);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.rk(JsWebSocketSession$lambda_2(this));
    }
  }
  protoOf(JsWebSocketSession).pj = function () {
    return this.u4r_1;
  };
  function unwrapCancellationException(_this__u8e3s4) {
    var exception = _this__u8e3s4;
    $l$loop: while (exception instanceof CancellationException) {
      if (equals(exception, exception.cause)) {
        return _this__u8e3s4;
      }
      exception = exception.cause;
    }
    var tmp0_elvis_lhs = exception;
    return tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  }
  //region block: post-declaration
  defineProp(protoOf(DoubleReceiveException), 'message', function () {
    return this.z8();
  });
  defineProp(protoOf(NoTransformationFoundException), 'message', function () {
    return this.z8();
  });
  defineProp(protoOf(ClientEngineClosedException), 'cause', function () {
    return this.a9();
  });
  protoOf(HttpClientEngineBase).f3z = get_supportedCapabilities;
  protoOf(HttpClientEngineBase).p3u = install;
  protoOf(KtorCallContextElement).w8 = get;
  protoOf(KtorCallContextElement).ke = fold;
  protoOf(KtorCallContextElement).je = minusKey;
  protoOf(KtorCallContextElement).le = plus;
  defineProp(protoOf(RedirectResponseException), 'message', function () {
    return this.z8();
  });
  defineProp(protoOf(ClientRequestException), 'message', function () {
    return this.z8();
  });
  defineProp(protoOf(ServerResponseException), 'message', function () {
    return this.z8();
  });
  protoOf(HttpRequest$1).pj = get_coroutineContext;
  //endregion
  //region block: init
  Companion_instance_1 = new Companion_0();
  WebSocketCapability_instance = new WebSocketCapability();
  Companion_instance_4 = new Companion_3();
  Js_instance = new Js();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Js_instance;
  _.$_$.b = Plugin_getInstance_6;
  _.$_$.c = Phases_getInstance;
  _.$_$.d = Phases_getInstance_0;
  _.$_$.e = Phases_getInstance_2;
  _.$_$.f = Phases_getInstance_1;
  _.$_$.g = EmptyContent_getInstance;
  _.$_$.h = ResponseObserver;
  _.$_$.i = HttpClientPlugin;
  _.$_$.j = HttpResponseValidator;
  _.$_$.k = ResponseException;
  _.$_$.l = defaultRequest;
  _.$_$.m = HttpRequestBuilder;
  _.$_$.n = HttpRequest_0;
  _.$_$.o = accept;
  _.$_$.p = url;
  _.$_$.q = HttpResponseContainer;
  _.$_$.r = HttpResponse;
  _.$_$.s = HttpStatement;
  _.$_$.t = HttpClient_0;
  _.$_$.u = HttpClient;
  //endregion
  return _;
}));
